<template>
  <el-main class="pageStudentDetail" style="padding: 0">
    <div class="navs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{path:'/normal_user_list'}">
          <a>用户管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>代理详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
<!--    <div class="backPage" @click="pageBack">-->
<!--      <el-button icon="el-icon-arrow-left" plain>返回</el-button>-->
<!--    </div>-->
    <div class="clientContent">
      <div v-loading="loading" class="paraContent_body">
        <div v-if="stu != null" class="stuDetailContent0">
          <div class="stuDetailContent1">
            <div class="userHead">
              <img :src="stu.user_head" alt />
              <div>
                <span style="margin-right:10px">{{stu.username}}</span>
                <span v-if="stu.sex == 1" style="color:blue">男</span>
                <span v-if="stu.sex == 2" style="color:red">女</span>
                <span v-if="stu.user_type == 1">个人</span>
                <span v-if="stu.user_type == 2">企业</span>
              </div>

              <div>
                <span v-if="stu.role_type == -1" style="color:green">无</span>
                <span v-if="stu.role_type == -0.5" style="color:green">康减系列vip会员</span>
                <span v-if="stu.role_type == -0.4" style="color:green">康减系列高级会员</span>
                <span v-if="stu.role_type == -0.3" style="color:green">康减系列荣誉会员</span>

                <span v-if="stu.role_type == 1.1" style="color:green">康减系列市代</span>
                <span v-if="stu.role_type == 2.1" style="color:green">康减系列省代</span>
                <span v-if="stu.role_type == 3.1" style="color:green">康减系列CEO</span>

                <span v-if="stu.role_type == 0" style="color:green">VIP门店</span>
                <span v-if="stu.role_type == 1" style="color:green">联盟店</span>
                <span v-if="stu.role_type == 1.05" style="color:green">优秀联盟店</span>
                <span v-if="stu.role_type == 2" style="color:green">市代</span>
                <span v-if="stu.role_type == 3" style="color:green">省代</span>
                <span v-if="stu.role_type == 4" style="color:green">CEO</span>
                <span v-if="stu.role_type == 5" style="color:green">总经销商</span>

                <span v-if="stu.role_type == 2.2" style="color:green">合伙人</span>
                <span v-if="stu.role_type == 4.2" style="color:green">董事</span>
                <span v-if="stu.role_type == 4.8" style="color:green">经销商</span>
                <span v-if="stu.role_type == 5.1" style="color:green">区域总监</span>
                <span v-if="stu.role_type == 5.2" style="color:green">城市加盟商</span>
              </div>
            </div>
            <div class="userInfo">
              <!-- <div class="baseUserInfo">
                <div class="base_label">基本信息</div>
                <div>
                  联系电话：{{stu.telephone}}
                </div>
              </div>-->
              <div class="moreUserInfo">
                <div class="base_label">基本信息</div>
                <ul>
                  <li>
                    <font class="colorC fontWidth">联系电话：</font>
                    {{stu.telephone}}
                  </li>
                  <li>
                    <font class="colorC fontWidth">真实姓名：</font>
                    {{stu.real_name}}
                  </li>

                  <li>
                    <font class="colorC fontWidth">身份证号：</font>
                    {{stu.id_code}}
                  </li>
                  <li>
                    <font class="colorC fontWidth">微信号：</font>
                    {{stu.chat_status == 1 ? '未绑定':'已绑定'}}
                  </li>
                  <li>
                    <font class="colorC fontWidth">注册时间：</font>
                    {{stu.create_time}}
                  </li>
                  <li>
                    <font class="colorC fontWidth">保证金：</font>
                    {{stu.deposit}}/{{stu.deposit_need}}
                  </li>
                  <li>
                    <font class="colorC fontWidth">团长推荐码：</font>
                    {{stu.recommend_code}}
                  </li>
                  <li>
                    <font class="colorC fontWidth">上级：</font>
                    {{stu.up_name}}（{{stu.up_tel}}）
                  </li>
                  <li>
                    <font class="colorC fontWidth">上上级：</font>
                    {{stu.top_name}}（{{stu.top_tel}}）
                  </li>

                  <li>
                    <font class="colorC fontWidth">第二上级：</font>
                    {{stu.secondUpName}}（{{stu.secondUpTel}}）
                  </li>
                  <li>
                    <font class="colorC fontWidth">第二上上级：</font>
                    {{stu.secondTopName}}（{{stu.secondTopTel}}）
                  </li>

                  <li>
                    <font class="colorC fontWidth">推荐人：</font>
                    {{stu.recommen_name}}
                  </li>
                  <li>
                    <font class="colorC fontWidth">地址：</font>
                    {{stu.province}}{{stu.city}}{{stu.district}}
                  </li>
                  <li>
                    <font class="colorC fontWidth">店铺名称：</font>
                    {{stu.show_name}}
                  </li>
                   <li>
                    <font class="colorC fontWidth">通联状态：</font>
                    {{stu.open_status1}}<el-button
                        @click="showTBalance1(stu.user_type)"
                        type="text"
                        size="small"
                      >查看</el-button>
                  </li>
                  <li v-if="stu.user_type == 2">
                    <font class="colorC fontWidth">企业名称：</font>
                    {{stu.company_name}}
                  </li>
                  <li v-if="stu.user_type == 2">
                    <font class="colorC fontWidth">营业执照编号：</font>
                    {{stu.uni_credit}}
                  </li>
                </ul>
              </div>

              <div class="moreUserInfo">
                <div class="base_label">资金信息</div>
                <ul>
                  <li>
                    <font class="colorC fontWidth">余额：</font>
                    {{stu.balance}}  <el-button
                        @click="showTBalance()"
                        type="text"
                        size="small"
                      >查看通联余额</el-button>
                  </li>

                  <!-- <li>
                    <font class="colorC fontWidth">个人奖励：</font>
                    {{stu.no_balance}}
                  </li>

                  <li>
                    <font class="colorC fontWidth">目标奖励：</font>
                    {{stu.give_balance}}
                  </li>

                  <li>
                    <font class="colorC fontWidth">直属奖励：</font>
                    {{stu.down_balance}}
                  </li> -->

                  <li>
                    <font class="colorC fontWidth">积分：</font>
                    {{stu.sendScore}}
                    <el-button
                        @click="showScoreHistory()"
                        type="text"
                        size="small"
                    >变更积分</el-button>
                  </li>

                  <li>
                    <font class="colorC fontWidth">红包余额：</font>
                    {{stu.red_balance}}
                  </li>
                  <li>
                    <font class="colorC fontWidth">保证金：</font>
                    {{stu.deposit}}/{{stu.deposit_need}}
                  </li>

                  <li>
                    <font class="colorC fontWidth">学习积分：</font>
                    {{stu.integral}}
                    <el-button
                        @click="showIntegralHistory()"
                        type="text"
                        size="small"
                    >转为余额</el-button>
                  </li>
                  <li v-if="stu.role_type == 5.2" >
                    <font class="colorC fontWidth">风险保证金：</font>
                    {{stu.execPrice}}
                    <el-button
                        @click="showRiskSet()"
                        type="text"
                        size="small"
                    >释放</el-button>
                  </li>

                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="stuDetailContent2">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <!-- <el-tab-pane
              label="数据统计"
              name="second"
            >
              <div
                style="width:100%;"
                :loading='get_group_user_countLoading'
              >
                <div class="data-count-div">
                  <div class="data-count-div-left">
                    <div class="data-count-div-head">
                      <div style="display: flex;align-items: center;">
                        <span class="title-left-s"></span>
                        个人订单收益
                      </div>
                      <el-date-picker
                        @change="get_group_user_count(1)"
                        v-model="perMoneyDate"
                        type="date"
                        size='small'
                        placeholder="选择日期"
                      >
                      </el-date-picker>
                    </div>
                    <div class="center-data-boy">
                      <div>
                        <span>当天利润</span>
                        <span>{{countInfo['order-today-li']}}</span>
                      </div>
                      <div>
                        <span>当天返利</span>
                        <span>{{countInfo['order-today-reward']}}</span>
                      </div>
                      <div>
                        <span>当月利润</span>
                        <span>{{countInfo['order-month-li']}}</span>
                      </div>
                      <div>
                        <span>当月返利</span>
                        <span>{{countInfo['order-month-reward']}}</span>
                      </div>
                      <div>
                        <span>累计利润</span>
                        <span>{{countInfo['order-total-li']}}</span>
                      </div>
                      <div>
                        <span>累计返利</span>
                        <span>{{countInfo['order-total-reward']}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="data-count-div-right">
                    <div class="data-count-div-head">
                      <div style="display: flex;align-items: center;">
                        <span class="title-left-s"></span>
                        个人订单销量
                      </div>
                      <el-date-picker
                        @change="get_group_user_count(2)"
                        v-model="perSaleDate"
                        type="date"
                        size='small'
                        placeholder="选择日期"
                      >
                      </el-date-picker>
                    </div>
                    <div class="center-data-boy">
                      <div>
                        <span>当天销量</span>
                        <span>{{countInfo['per-sale-today']}}</span>
                      </div>
                      <div>
                        <span>当月销量</span>
                        <span>{{countInfo['per-sale-month']}}</span>
                      </div>
                      <div>
                        <span>累计销量</span>
                        <span>{{countInfo['per-sale-total']}}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="data-count-div">
                  <div class="data-count-div-left">
                    <div class="data-count-div-head">
                      <div style="display: flex;align-items: center;">
                        <span class="title-left-s"></span>
                        个人活动订单收益
                      </div>
                      <el-date-picker
                        @change="get_group_user_count(3)"
                        v-model="perAcMoneyDate"
                        type="date"
                        size='small'
                        placeholder="选择日期"
                      >
                      </el-date-picker>
                    </div>
                    <div class="center-data-boy">
                      <div>
                        <span>当天利润</span>
                        <span>{{countInfo['ac-order-today-li']}}</span>
                      </div>
                      <div>
                        <span>当天返利</span>
                        <span>{{countInfo['ac-order-today-reward']}}</span>
                      </div>
                      <div>
                        <span>当月利润</span>
                        <span>{{countInfo['ac-order-month-li']}}</span>
                      </div>
                      <div>
                        <span>当月返利</span>
                        <span>{{countInfo['ac-order-month-reward']}}</span>
                      </div>
                      <div>
                        <span>累计利润</span>
                        <span>{{countInfo['ac-order-total-li']}}</span>
                      </div>
                      <div>
                        <span>累计返利</span>
                        <span>{{countInfo['ac-order-total-reward']}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="data-count-div-right">
                    <div class="data-count-div-head">
                      <div style="display: flex;align-items: center;">
                        <span class="title-left-s"></span>
                        个人活动订单销量
                      </div>
                      <el-date-picker
                        @change="get_group_user_count(4)"
                        v-model="perAcSaleDate"
                        type="date"
                        size='small'
                        placeholder="选择日期"
                      >
                      </el-date-picker>
                    </div>
                    <div class="center-data-boy">
                      <div>
                        <span>当天销量</span>
                        <span>{{countInfo['ac-per-sale-today']}}</span>
                      </div>
                      <div>
                        <span>当月销量</span>
                        <span>{{countInfo['ac-per-sale-month']}}</span>
                      </div>
                      <div>
                        <span>累计销量</span>
                        <span>{{countInfo['ac-per-sale-total']}}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="data-count-div">
                  <div class="data-count-div-left">
                    <div class="data-count-div-head">
                      <div style="display: flex;align-items: center;">
                        <span class="title-left-s"></span>
                        团队订单收益
                      </div>
                      <el-date-picker
                        @change="get_group_user_count(5)"
                        v-model="groupMoneyDate"
                        type="date"
                        size='small'
                        placeholder="选择日期"
                      >
                      </el-date-picker>
                    </div>
                    <div class="center-data-boy">
                      <div>
                        <span>当天利润</span>
                        <span>{{countInfo['group-order-today-li']}}</span>
                      </div>
                      <div>
                        <span>当天返利</span>
                        <span>{{countInfo['group-order-today-reward']}}</span>
                      </div>
                      <div>
                        <span>当月利润</span>
                        <span>{{countInfo['group-order-month-li']}}</span>
                      </div>
                      <div>
                        <span>当月返利</span>
                        <span>{{countInfo['group-order-month-reward']}}</span>
                      </div>
                      <div>
                        <span>累计利润</span>
                        <span>{{countInfo['group-order-total-li']}}</span>
                      </div>
                      <div>
                        <span>累计返利</span>
                        <span>{{countInfo['group-order-total-reward']}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="data-count-div-right">
                    <div class="data-count-div-head">
                      <div style="display: flex;align-items: center;">
                        <span class="title-left-s"></span>
                        团队订单销量
                      </div>
                      <el-date-picker
                        @change="get_group_user_count(6)"
                        v-model="groupSaleDate"
                        type="date"
                        size='small'
                        placeholder="选择日期"
                      >
                      </el-date-picker>
                    </div>
                    <div class="center-data-boy">
                      <div>
                        <span>当天销量</span>
                        <span>{{countInfo['group-sale-today']}}</span>
                      </div>
                      <div>
                        <span>当月销量</span>
                        <span>{{countInfo['group-sale-month']}}</span>
                      </div>
                      <div>
                        <span>累计销量</span>
                        <span>{{countInfo['group-sale-total']}}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="data-count-div">
                  <div class="data-count-div-left">
                    <div class="data-count-div-head">
                      <div style="display: flex;align-items: center;">
                        <span class="title-left-s"></span>
                        活动团队订单收益
                      </div>
                      <el-date-picker
                        @change="get_group_user_count(7)"
                        v-model="groupAcMoneyDate"
                        type="date"
                        size='small'
                        placeholder="选择日期"
                      >
                      </el-date-picker>
                    </div>
                    <div class="center-data-boy">
                      <div>
                        <span>当天利润</span>
                        <span>{{countInfo['group-ac-order-today-li']}}</span>
                      </div>
                      <div>
                        <span>当天返利</span>
                        <span>{{countInfo['group-ac-order-today-reward']}}</span>
                      </div>
                      <div>
                        <span>当月利润</span>
                        <span>{{countInfo['group-ac-order-month-li']}}</span>
                      </div>
                      <div>
                        <span>当月返利</span>
                        <span>{{countInfo['group-ac-order-month-reward']}}</span>
                      </div>
                      <div>
                        <span>累计利润</span>
                        <span>{{countInfo['group-ac-order-total-li']}}</span>
                      </div>
                      <div>
                        <span>累计返利</span>
                        <span>{{countInfo['group-ac-order-total-reward']}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="data-count-div-right">
                    <div class="data-count-div-head">
                      <div style="display: flex;align-items: center;">
                        <span class="title-left-s"></span>
                        活动团队订单销量
                      </div>
                      <el-date-picker
                        @change="get_group_user_count(8)"
                        v-model="groupAcSaleDate"
                        type="date"
                        size='small'
                        placeholder="选择日期"
                      >
                      </el-date-picker>
                    </div>
                    <div class="center-data-boy">
                      <div>
                        <span>当天销量</span>
                        <span>{{countInfo['ac-group-sale-today']}}</span>
                      </div>
                      <div>
                        <span>当月销量</span>
                        <span>{{countInfo['ac-group-sale-month']}}</span>
                      </div>
                      <div>
                        <span>累计销量</span>
                        <span>{{countInfo['ac-group-sale-total']}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-tab-pane>-->
            <el-tab-pane label="我的业绩" name="yeji">
              <div class="contain_div">
                <div class="contain_header clr">
                  <el-form :inline="true" class="m-search" size="small" :model="filtersY">
                    <el-form-item label="查询月份">
                      <el-form-item prop="startTime">
                        <el-date-picker v-model="filtersY.month" type="month" placeholder="选择月"></el-date-picker>
                      </el-form-item>
                    </el-form-item>
                    <el-form-item label="类型">
                      <el-select v-model="filtersY.type">
                        <el-option label="团队业绩" value="1"></el-option>
                        <el-option label="推荐业绩" value="2"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" @click="handleSearchYeji">搜索</el-button>
                    </el-form-item>
                  </el-form>
                </div>

                <div class="contain_body">
                  <div
                    class="contain_body_head"
                  >个人进货：{{yejiMap.monthSaleIn}}，个人销售：{{yejiMap.monthSaleMoney}}，个人利润：{{yejiMap.monthSaleLi}}，团队业绩：{{yejiMap.groupTotal}}</div>
                  <el-table
                    v-loading="listLoadingY"
                    :data="tableDataY"
                    style="width: 100%"
                    :header-cell-class-name="objectSpanMethod"
                  >
                    <el-table-column prop="username" label="用户姓名"></el-table-column>

                    <el-table-column label="用户头像">
                      <template slot-scope="scope">
                        <img :src="scope.row.userHead" style="width:50px;height:50px" />
                      </template>
                    </el-table-column>

                    <el-table-column prop="roleType" :formatter="formatterRoleType" label="代理类型"></el-table-column>
                    <el-table-column prop="targetM" label="考核金额"></el-table-column>
                    <el-table-column prop="saleM" label="进货金额">
                      <template></template>
                    </el-table-column>

                    <el-table-column prop="total_money" label="销售金额"></el-table-column>

                    <el-table-column prop="get_money" label="利润"></el-table-column>
                  </el-table>
                  <div class="pageDiv block">
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChangeY"
                      :current-page.sync="page_num1Y"
                      :page-count="total_page1Y"
                      :page-size="page_size1Y"
                      layout="total, prev, pager, next"
                      :total="total_num1Y"
                    ></el-pagination>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="银行卡" name="third">
              <el-table
                v-loading="bankListVisibleLoading"
                :data="tableData1"
                style="width: 100%"
                :header-cell-class-name="objectSpanMethod"
              >
                <el-table-column prop="username" label="姓名"></el-table-column>

                <el-table-column prop="bankName" label="银行名称"></el-table-column>
                <el-table-column prop="bankCode" label="银行卡号"></el-table-column>
                <el-table-column prop="openBank" label="开户行"></el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="充值" name="three">
              <div class="contain_div">
                <div class="contain_header clr">
                  <el-form :inline="true" class="m-search" size="small" :model="filtersIn">
                    <el-form-item label="查询时间">
                      <el-form-item prop="startTime">
                        <el-date-picker
                          type="date"
                          placeholder="选择开始日期"
                          v-model="filtersIn.startTime"
                          style="width: 100%;"
                        ></el-date-picker>
                      </el-form-item>
                      <span style="display: inline-block;margin-right: 9px;">-</span>
                      <el-form-item prop="endTime">
                        <el-date-picker
                          type="date"
                          placeholder="选择结束日期"
                          v-model="filtersIn.endTime"
                          style="width: 100%;"
                        ></el-date-picker>
                      </el-form-item>
                    </el-form-item>
                    <el-form-item label="状态">
                      <el-select v-model="filtersIn.status" clearable>
                        <el-option label="充值中" value="1"></el-option>
                        <el-option label="充值成功" value="2"></el-option>
                        <el-option label="充值失败" value="3"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" @click="handleSearchIn">搜索</el-button>
                    </el-form-item>
                  </el-form>
                </div>

                <div class="contain_body">
                  <div class="contain_body_head">充值总金额：{{inTotal}}</div>
                  <el-table
                    v-loading="listLoading"
                    :data="tableData"
                    style="width: 100%"
                    :header-cell-class-name="objectSpanMethod"
                  >
                    <el-table-column prop="username" label="用户姓名"></el-table-column>

                    <el-table-column label="用户头像">
                      <template slot-scope="scope">
                        <img :src="scope.row.user_head" style="width:50px;height:50px" />
                      </template>
                    </el-table-column>

                    <!-- :show-overflow-tooltip="true" -->
                    <el-table-column prop="pay_money" label="充值金额"></el-table-column>
                    <el-table-column prop="create_time" label="申请时间"></el-table-column>
                    <el-table-column prop="account_code" label="支付宝账户"></el-table-column>

                    <el-table-column label="图片">
                      <template slot-scope="scope">
                        <el-popover placement="top" title trigger="hover">
                          <img style="max-height: 200px;max-width: 200px" :src="scope.row.pay_img" />
                          <img
                            slot="reference"
                            :src="scope.row.pay_img"
                            :alt="scope.row.pay_img"
                            style="max-height: 50px;max-width: 130px"
                          />
                        </el-popover>
                      </template>
                    </el-table-column>

                    <el-table-column prop="status" label="审核状态">
                      <template slot-scope="scope">
                        <el-tag v-if="scope.row.status == 2" type="success" disable-transitions>充值成功</el-tag>
                        <el-tag v-if="scope.row.status == 1" disable-transitions>充值中</el-tag>
                        <el-tag v-if="scope.row.status == 3" type="danger" disable-transitions>充值失败</el-tag>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="pageDiv block">
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChangeIn"
                      :current-page.sync="page_num1"
                      :page-count="total_page1"
                      :page-size="page_size1"
                      layout="total, prev, pager, next"
                      :total="total_num1"
                    ></el-pagination>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="提现" name="four">
              <div class="contain_div">
                <div class="contain_header clr">
                  <el-form :inline="true" class="m-search" size="small" :model="filtersOut">
                    <el-form-item label="查询时间">
                      <el-form-item prop="startTime">
                        <el-date-picker
                          type="date"
                          placeholder="选择开始日期"
                          v-model="filtersOut.startTime"
                          style="width: 100%;"
                        ></el-date-picker>
                      </el-form-item>
                      <span style="display: inline-block;margin-right: 9px;">-</span>
                      <el-form-item prop="endTime">
                        <el-date-picker
                          type="date"
                          placeholder="选择结束日期"
                          v-model="filtersOut.endTime"
                          style="width: 100%;"
                        ></el-date-picker>
                      </el-form-item>
                    </el-form-item>
                    <el-form-item label="审核类型">
                      <el-select v-model="filtersOut.status" clearable>
                        <el-option label="申请中" value="1"></el-option>
                        <el-option label="申请通过" value="2"></el-option>
                        <el-option label="申请拒绝" value="3"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" @click="handleSearch">搜索</el-button>
                    </el-form-item>
                  </el-form>
                </div>

                <div class="contain_body">
                  <div class="contain_body_head">提现总金额：{{outTotal}}</div>
                  <el-table
                    v-loading="listLoadingOut"
                    :data="tableDataOut"
                    style="width: 100%"
                    :header-cell-class-name="objectSpanMethod"
                  >
                    <el-table-column prop="username" label="用户姓名"></el-table-column>

                    <el-table-column label="用户头像">
                      <template slot-scope="scope">
                        <img :src="scope.row.user_head" style="width:50px;height:50px" />
                      </template>
                    </el-table-column>

                    <!-- :show-overflow-tooltip="true" -->
                    <el-table-column prop="total_money" label="提现金额">
                      <template
                        slot-scope="scope"
                      >{{scope.row.pay_money}}(提现金额) - {{scope.row.rate_money}}(手续费) = {{scope.row.total_money}}</template>
                    </el-table-column>
                    <el-table-column prop="create_time" label="申请时间"></el-table-column>
                    <el-table-column prop="bank_name" label="银行名称"></el-table-column>
                    <el-table-column prop="bank_code" label="银行账户"></el-table-column>
                    <el-table-column prop="bank_username" label="银行留存姓名"></el-table-column>

                    <el-table-column prop="status" label="审核状态">
                      <template slot-scope="scope">
                        <el-tag v-if="scope.row.status == 2" type="success" disable-transitions>审核成功</el-tag>
                        <el-tag v-if="scope.row.status == 1" disable-transitions>审核中</el-tag>
                        <el-tag v-if="scope.row.status == 3" type="danger" disable-transitions>审核失败</el-tag>
                      </template>
                    </el-table-column>
                    <!-- <el-table-column label="操作" width="100">
                      <template slot-scope="scope">
                        <template v-if="scope.row.status == 1">
                          <el-button
                            @click="upHouseStatusOut(scope.row,2)"
                            type="text"
                            size="small"
                          >通过</el-button>
                          <el-button
                            @click="upHouseStatusOut(scope.row,3)"
                            type="text"
                            size="small"
                          >拒绝</el-button>
                        </template>
                      </template>
                    </el-table-column> -->
                  </el-table>
                  <div class="pageDiv block">
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"
                      :current-page.sync="page_num11"
                      :page-count="total_page11"
                      :page-size="page_size11"
                      layout="total, prev, pager, next"
                      :total="total_num11"
                    ></el-pagination>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="交易记录" name="fifth">
              <div class="contain_div">
                <div class="contain_header clr">
                  <el-form :inline="true" class="m-search" size="small" :model="filtersOrder">
                    <el-form-item label="查询时间">
                      <el-form-item prop="startTime">
                        <el-date-picker
                          type="date"
                          placeholder="选择开始日期"
                          v-model="filtersOrder.startTime"
                          style="width: 100%;"
                        ></el-date-picker>
                      </el-form-item>
                      <span style="display: inline-block;margin-right: 9px;">-</span>
                      <el-form-item prop="endTime">
                        <el-date-picker
                          type="date"
                          placeholder="选择结束日期"
                          v-model="filtersOrder.endTime"
                          style="width: 100%;"
                        ></el-date-picker>
                      </el-form-item>
                    </el-form-item>

                    <el-form-item label="交易类型">
                      <el-select v-model="filtersOrder.type" clearable @change="changeInfoType">
                        <el-option v-for="(item,index) in infoTypeList" :key="index" :label="item.label" :value="item.value"></el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item label="交易状态" v-if='showStatus'>
                      <el-select v-model="filtersOrder.status" clearable>
                        <el-option v-for="(item,index) in statusList" :key="index" :label="item.label" :value="item.value"></el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item>
                      <el-button type="primary" @click="handleSearchOrder">搜索</el-button>
                      <el-button type="primary" @click="excelOutOSix">导出</el-button>
                    </el-form-item>
                  </el-form>
                </div>

                <div class="contain_body">
                  <!-- <div class="contain_body_head">
                    消费总金额：{{useTotal}}
                  </div>-->
                  <el-table
                    v-loading="listLoading3"
                    :data="tableData4"
                    style="width: 100%"
                    :header-cell-class-name="objectSpanMethod"
                  >
                    <el-table-column prop="order_code" label="流水号"></el-table-column>

                    <el-table-column prop="info_money" label="交易金额"></el-table-column>

                    <el-table-column prop="info_type" label="交易类型"></el-table-column>

                    <el-table-column prop="status" label="交易状态"></el-table-column>

                    <el-table-column prop="create_time" label="交易时间"></el-table-column>
                  </el-table>
                  <div class="pageDiv block">
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChangeOrde"
                      :current-page.sync="page_num5"
                      :page-count="total_page5"
                      :page-size="page_size5"
                      layout="total, prev, pager, next"
                      :total="total_num5"
                    ></el-pagination>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="风险保证金" name="riskPane">
              <div class="contain_div">
                <div class="contain_header clr">
                  <el-form :inline="true" class="m-search" size="small" :model="filtersOrderRisk">
                    <el-form-item label="查询时间">
                      <el-form-item prop="startTime">
                        <el-date-picker
                          type="date"
                          placeholder="选择开始日期"
                          v-model="filtersOrderRisk.startTime"
                          style="width: 100%;"
                        ></el-date-picker>
                      </el-form-item>
                      <span style="display: inline-block;margin-right: 9px;">-</span>
                      <el-form-item prop="endTime">
                        <el-date-picker
                          type="date"
                          placeholder="选择结束日期"
                          v-model="filtersOrderRisk.endTime"
                          style="width: 100%;"
                        ></el-date-picker>
                      </el-form-item>
                    </el-form-item>

                    <el-form-item label="交易类型">
                      <el-select v-model="filtersOrderRisk.type" clearable>
                        <el-option label="增加" value="1"></el-option>
                        <el-option label="释放" value="2"></el-option>
                      </el-select>
                    </el-form-item>


                    <el-form-item>
                      <el-button type="primary" @click="handleSearchRiskOrder">搜索</el-button>
                    </el-form-item>
                  </el-form>
                </div>

                <div class="contain_body">

                  <el-table
                    v-loading="listLoading3"
                    :data="tableData91"
                    style="width: 100%"
                    :header-cell-class-name="objectSpanMethod"
                  >

                    <el-table-column prop="op_money" label="金额"></el-table-column>

                    <el-table-column prop="op_type" label="交易类型"></el-table-column>

                    <el-table-column prop="create_time" label="交易时间"></el-table-column>
                  </el-table>
                  <div class="pageDiv block">
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChangeOrde"
                      :current-page.sync="page_num91"
                      :page-count="total_page91"
                      :page-size="page_size91"
                      layout="total, prev, pager, next"
                      :total="total_num5"
                    ></el-pagination>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="学习积分明细" name="integral">
              <div class="contain_div">
                <!-- <div class="contain_header clr">
                </div> -->

                <div class="contain_body">
                  <el-table
                    v-loading="listLoading20"
                    :data="tableData20"
                    style="width: 100%"
                    :header-cell-class-name="objectSpanMethod"
                  >
                    <el-table-column prop="infoTypeName" label="加/减"></el-table-column>

                    <el-table-column prop="integral" label="积分"></el-table-column>

                    <el-table-column prop="create_time" label="交易时间"></el-table-column>
                  </el-table>
                  <div class="pageDiv block">
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChangeIntegral"
                      :current-page.sync="page_num20"
                      :page-count="total_page20"
                      :page-size="page_size20"
                      layout="total, prev, pager, next"
                      :total="total_num20"
                    ></el-pagination>
                  </div>
                </div>
              </div>
            </el-tab-pane>


            <el-tab-pane label="订单列表" name="six">
              <div class="contain_div">
                <div class="contain_header clr">
                  <el-form :inline="true" class="m-search" size="small" :model="filtersReward">
                    <el-form-item label="查询时间">
                      <el-form-item prop="startTime">
                        <el-date-picker
                          type="date"
                          placeholder="选择开始日期"
                          v-model="filtersReward.startTime"
                          style="width: 100%;"
                        ></el-date-picker>
                      </el-form-item>
                      <span style="display: inline-block;margin-right: 9px;">-</span>
                      <el-form-item prop="endTime">
                        <el-date-picker
                          type="date"
                          placeholder="选择结束日期"
                          v-model="filtersReward.endTime"
                          style="width: 100%;"
                        ></el-date-picker>
                      </el-form-item>
                    </el-form-item>

                    <el-form-item label="订单类型">
                      <el-select @change="handleSearchReward" v-model="filtersReward.orderType">
                        <el-option label="发货订单" value="1"></el-option>
                        <el-option label="购进订单" value="2"></el-option>
                        <el-option label="销售订单" value="5"></el-option>
                        <el-option label="待补货订单" value="3"></el-option>
                        <el-option label="补货订单" value="4"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" @click="handleSearchReward">搜索</el-button>

                      <!-- <el-button
                        type="primary"
                        @click="excelOut2"
                      >导出</el-button>-->
                    </el-form-item>
                  </el-form>
                </div>

                <div class="contain_body">
                  <!-- <div class="contain_body_head">
                    打赏金额：{{rewardTotal}}
                  </div>-->
                  <el-table
                    v-loading="listLoading2"
                    :data="tableData2"
                    style="width: 100%"
                    :header-cell-class-name="objectSpanMethod"
                  >
                    <el-table-column prop="username" label="代理姓名"></el-table-column>

                    <el-table-column label="代理头像">
                      <template slot-scope="scope">
                        <img :src="scope.row.user_head" style="width:50px;" />
                      </template>
                    </el-table-column>
                    <el-table-column prop="order_code" label="订单号"></el-table-column>

                    <el-table-column prop="total_money" label="总金额"></el-table-column>
                    <!-- :show-overflow-tooltip="true" -->
                    <el-table-column prop="create_time" label="下单时间"></el-table-column>
                    <el-table-column prop="order_type" :formatter="formatterOrderType" label="订单类型"></el-table-column>

                    <el-table-column
                      prop="postage_status"
                      v-if="filtersReward.orderType == 1"
                      label="包邮状态"
                    >
                      <template slot-scope="scope">
                        <el-tag
                          v-if="scope.row.postage_status == 1"
                          type="success"
                          disable-transitions
                        >包邮</el-tag>
                        <el-tag
                          v-if="scope.row.postage_status == 2"
                          type="info"
                          disable-transitions
                        >不包邮</el-tag>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="postage_type"
                      v-if="filtersReward.orderType == 1"
                      label="送货类型"
                      width="150px"
                      :show-overflow-tooltip="true"
                    >
                      <template slot-scope="scope">
                        <el-tag
                          v-if="scope.row.postage_type == 1"
                          type="success"
                          disable-transitions
                        >自提</el-tag>
                        <el-tag
                          v-if="scope.row.postage_type == 2"
                          type="success"
                          disable-transitions
                        >快递</el-tag>
                      </template>
                    </el-table-column>

                    <el-table-column
                      v-if="filtersReward.orderType == 1"
                      prop="province"
                      label="地址信息 "
                      :show-overflow-tooltip="true"
                    >
                      <template
                        slot-scope="scope"
                      >{{scope.row.add_name }} {{scope.row.add_tel }} {{scope.row.province }}{{scope.row.city }}{{scope.row.district }}{{scope.row.address_detail }}</template>
                    </el-table-column>

                    <el-table-column prop="status" :formatter="formatterOrderStatus" label="状态"></el-table-column>

                    <el-table-column prop="order_info" label="订单备注"></el-table-column>

                    <el-table-column prop="status" label="订单详情">
                      <template slot-scope="scope">
                        <!-- <el-button @click="showOrderDetail(scope.row)">查看</el-button> -->
                        <router-link
                          target="_blank"
                          :to="{path:'/orderDetail',query:{orderId:scope.row.id}}"
                        >查看</router-link>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="pageDiv block">
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChangeReward"
                      :current-page.sync="page_num3"
                      :page-count="total_page3"
                      :page-size="page_size3"
                      layout="total, prev, pager, next"
                      :total="total_num3"
                    ></el-pagination>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="我的团队" name="seven">
              <div class="contain_div">
                <div class="contain_header clr">
                  <el-form :inline="true" class="m-search" size="small" :model="filters">
                    <el-form-item label="关键字">
                      <el-input
                        style="width:300px"
                        v-model="filtersGroup.username"
                        placeholder="请输入团长姓名、推荐码或者手机号"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="类型">
                      <el-select v-model="filtersGroup.type" clearable>
                        <el-option label="直属" value="1"></el-option>
                        <el-option label="非直属" value="2"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="状态">
                      <el-select v-model="filtersGroup.status" clearable>
                        <el-option label="正常" value="1"></el-option>
                        <el-option label="禁用" value="2"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="代理级别">
                      <el-select v-model="filtersGroup.roleType" clearable>
                        <el-option label="康减系列vip会员" value="-0.5"></el-option>
                        <el-option label="康减系列高级会员" value="-0.4"></el-option>
                        <el-option label="康减系列荣誉会员" value="-0.3"></el-option>

                        <el-option label="康减系列市代" value="1.1"></el-option>
                        <el-option label="康减系列省代" value="2.1"></el-option>
                        <el-option label="康减系列CEO" value="3.1"></el-option>

                        <el-option label="VIP门店" value="0"></el-option>
                        <el-option label="联盟店" value="1"></el-option>
                        <el-option label="优秀联盟店" value="1.05"></el-option>
                        <el-option label="市代" value="2"></el-option>
                        <el-option label="省代" value="3"></el-option>
                        <el-option label="CEO" value="4"></el-option>
                        <el-option label="总经销商" value="5"></el-option>

                        <el-option label="合伙人" value="2.2"></el-option>
                        <el-option label="董事" value="4.2"></el-option>
                <el-option label="经销商" value="4.8"></el-option>
                        <el-option label="区域总监" value="5.1"></el-option>
                        <el-option label="城市加盟商" value="5.2"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" @click="handleCurrentChangeGroup">搜索</el-button>

                      <el-button type="primary" @click="excelOut">导出</el-button>
                    </el-form-item>
                  </el-form>
                </div>

                <div class="contain_body">
                  <div class="contain_body_head">
                    <div>
                      <span
                        style="margin-right:10px"
                      >业绩总和：{{groupMap.saleTotal}}，非直属代理：{{groupMap.secondT}}</span>
                      /直属代理：{{groupMap.firstT}}
                    </div>
                  </div>
                  <el-table
                    v-loading="listLoading1"
                    :data="tableDataGroup"
                    style="width: 100%"
                    :header-cell-class-name="objectSpanMethod"
                  >
                    <el-table-column prop="username" label="用户姓名"></el-table-column>

                    <el-table-column prop="telephone" label="手机号"></el-table-column>

                    <el-table-column label="用户头像">
                      <template slot-scope="scope">
                        <img :src="scope.row.userHead" style="width:50px;height:50px" />
                      </template>
                    </el-table-column>
                    <el-table-column prop="roleType" :formatter="formatterRoleType" label="代理级别"></el-table-column>
                    <el-table-column prop="province" label="省"></el-table-column>
                    <el-table-column prop="city" label="市"></el-table-column>
                    <el-table-column prop="district" label="区"></el-table-column>
                    <el-table-column prop="address_detail" label="详细地址"></el-table-column>
                    <el-table-column prop="create_time" label="注册时间"></el-table-column>
                    <el-table-column prop="firstN" label="直属代理"></el-table-column>
                    <el-table-column prop="status" :formatter="formatterUserStatus" label="状态"></el-table-column>
                  </el-table>
                  <div class="pageDiv block">
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChangeGroup"
                      :current-page.sync="page_num2"
                      :page-count="total_page2"
                      :page-size="page_size2"
                      layout="total, prev, pager, next"
                      :total="total_num2"
                    ></el-pagination>
                  </div>
                </div>
              </div>
            </el-tab-pane>

            <el-tab-pane label="档案信息" name="mm_fuww">
              <div class="contain_div">
                <!-- <div class="contain_header clr"> -->
                  <!-- <el-form :inline="true" class="m-search" size="small" :model="filters">
                    <el-form-item label="关键字">
                      <el-input
                        style="width:300px"
                        v-model="filtersGroup.username"
                        placeholder="请输入团长姓名、推荐码或者手机号"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="类型">
                      <el-select v-model="filtersGroup.type" clearable>
                        <el-option label="直属" value="1"></el-option>
                        <el-option label="非直属" value="2"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="状态">
                      <el-select v-model="filtersGroup.status" clearable>
                        <el-option label="正常" value="1"></el-option>
                        <el-option label="禁用" value="2"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="代理级别">
                      <el-select v-model="filtersGroup.roleType" clearable>
                        <el-option label="康减系列vip会员" value="-0.5"></el-option>
                        <el-option label="康减系列高级会员" value="-0.4"></el-option>
                        <el-option label="康减系列荣誉会员" value="-0.3"></el-option>

                        <el-option label="康减系列市代" value="1.1"></el-option>
                        <el-option label="康减系列省代" value="2.1"></el-option>
                        <el-option label="康减系列CEO" value="3.1"></el-option>

                        <el-option label="VIP门店" value="0"></el-option>
                        <el-option label="联盟店" value="1"></el-option>
                        <el-option label="优秀联盟店" value="1.05"></el-option>
                        <el-option label="市代" value="2"></el-option>
                        <el-option label="省代" value="3"></el-option>
                        <el-option label="CEO" value="4"></el-option>
                        <el-option label="总经销商" value="5"></el-option>

                        <el-option label="合伙人" value="2.2"></el-option>
                        <el-option label="董事" value="4.2"></el-option>
                        <el-option label="区域总监" value="5.1"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" @click="handleCurrentChangeGroup">搜索</el-button>

                      <el-button type="primary" @click="excelOut">导出</el-button>
                    </el-form-item>
                  </el-form> -->
                <!-- </div> -->

                <div class="contain_body">
                  <div class="contain_body_head">
                    <div>
                      <span
                        style="margin-right:10px"
                      >店名：{{followMap.storeName == null ? '暂无' : followMap.storeName}}；店家姓名：{{followMap.username == null ? '暂无' : followMap.username}}；
                      联系电话：{{followMap.telephone == null ? '暂无' : followMap.telephone}}；地址：{{followMap.address == null ? '暂无' : followMap.address}}；
                      店面面积：{{followMap.areaInfo == null ? '暂无' : followMap.areaInfo}}；员工人数：{{followMap.workerNum == null ? '暂无' : followMap.workerNum}}；经营年数：{{followMap.workYear == null ? '暂无' : followMap.workYear}}；
                      近3月业绩：{{followMap.nearSale == null ? '暂无' : followMap.nearSale}}；计划启动时间：{{followMap.openTime == null ? '暂无' : followMap.openTime}}；计划启动项目：{{followMap.openPro == null ? '暂无' : followMap.openPro}}；
                      备注:{{followMap.remark == null ? '暂无' : followMap.remark}}</span>

                    </div>
                  </div>
                  <el-table
                    v-loading="listLoading31"
                    :data="tableDataGroup31"
                    style="width: 100%"
                    :header-cell-class-name="objectSpanMethod"
                  >
                    <el-table-column prop="logInfo" label="描述"></el-table-column>

                    <el-table-column prop="addName" label="记录人"></el-table-column>
                    <el-table-column prop="createTime" label="记录时间"></el-table-column>

                  </el-table>
                  <div class="pageDiv block">
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChangeGroup"
                      :current-page.sync="page_num31"
                      :page-count="total_page31"
                      :page-size="page_size31"
                      layout="total, prev, pager, next"
                      :total="total_num31"
                    ></el-pagination>
                  </div>
                </div>
              </div>
            </el-tab-pane>

            <el-tab-pane label="收货地址" name="four_ua">
              <el-table
                v-loading="addVisibleLoading"
                :data="tableData33"
                style="width: 100%"
                :header-cell-class-name="objectSpanMethod"
              >
                <el-table-column prop="username" label="姓名"></el-table-column>

                <el-table-column prop="telephone" label="手机号"></el-table-column>
                <el-table-column prop="province" label="省"></el-table-column>
                <el-table-column prop="city" label="城市"></el-table-column>
                <el-table-column prop="district" label="区县"></el-table-column>
                <el-table-column prop="addressDetail" label="详细地址"></el-table-column>

                <el-table-column prop="defaultStatus" label="状态">
                  <template slot-scope="scope">
                    <span v-if="scope.row.defaultStatus==2">默认地址</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>

            <el-tab-pane label="仓库" name="cangku">
              <div class="contain_div">
                <div class="contain_header clr">
                  <el-form :inline="true" class="m-search" size="small" :model="filtersReward">
                    <!-- <el-form-item label="查询时间">
                      <el-form-item prop="startTime">
                        <el-date-picker
                          type="date"
                          placeholder="选择开始日期"
                          v-model="filtersReward.startTime"
                          style="width: 100%;"
                        ></el-date-picker>
                      </el-form-item>
                      <span style="display: inline-block;margin-right: 9px;">-</span>
                      <el-form-item prop="endTime">
                        <el-date-picker
                          type="date"
                          placeholder="选择结束日期"
                          v-model="filtersReward.endTime"
                          style="width: 100%;"
                        ></el-date-picker>
                      </el-form-item>

                    </el-form-item>-->

                    <el-form-item label="关键字">
                      <el-input
                        style="width:200px"
                        v-model="goodInfo"
                        placeholder="请输入商品名称"
                      ></el-input>

                    </el-form-item>

                    <el-form-item>


                      <el-button
                        type="primary"
                        @click="searchGoodList"
                      >搜索</el-button>

                      <el-button v-if="hasPower('40021991')"
                      type="primary"
                      @click="addStock"
                      >新增</el-button>

                      <el-button
                        type="primary"
                        @click="excelOut2"
                      >导出</el-button>
                    </el-form-item>
                  </el-form>
                </div>

                <div class="contain_body">
                  <!-- <div class="contain_body_head">
                    打赏金额：{{rewardTotal}}
                  </div>-->
                  <el-table
                    v-loading="listLoading255"
                    :data="tableData2G"
                    show-summary
                    style="width: 100%"
                    :header-cell-class-name="objectSpanMethod"
                  >
                    <el-table-column prop="good_name" label="商品名称"></el-table-column>

                    <el-table-column label="商品图片">
                      <template slot-scope="scope">
                        <img :src="scope.row.list_pic" style="width:50px;" />
                      </template>
                    </el-table-column>
                    <el-table-column prop="no_vip" label="是否为积分商品">
                      <template slot-scope="scope">
                        {{ scope.row.no_vip == 1 ? '否' : '是' }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="good_num" label="库存数量"></el-table-column>
                    <el-table-column prop="proxy_price" label="单价"></el-table-column>
                    <el-table-column prop="totalPrice" label="总价"></el-table-column>

                    <el-table-column label="操作" width="100">
                      <template slot-scope="scope">
                        <el-button @click="showEditForm(scope.row)" v-if="scope.row.id && hasPower('40021991')" type="text" size="small">修改库存</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="pageDiv block">
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChangeCangku"
                      :current-page.sync="page_num3G"
                      :page-count="total_page3G"
                      :page-size="page_size3G"
                      layout="total, prev, pager, next"
                      :total="total_num3G"
                    ></el-pagination>
                  </div>
                </div>
              </div>
            </el-tab-pane>


            <el-tab-pane label="积分明细" name="integral_detail">
                <div class="contain_div">

                    <div class="contain_header clr">
                        <el-form
                          :inline="true"
                          class="m-search"
                          size='small'
                          :model="filters30"
                        >
                        <el-form-item
                          label="查询时间"
                        >
                            <el-form-item prop="startTime">
                              <el-date-picker
                                type="datetime"
                                placeholder="选择开始日期"
                                v-model="filters30.startTime"
                                style="width: 100%;"
                              ></el-date-picker>
                            </el-form-item>
                            <span style="display: inline-block;margin-right: 9px;">-</span>
                            <el-form-item prop="endTime">
                              <el-date-picker
                                type="datetime"
                                placeholder="选择结束日期"
                                v-model="filters30.endTime"
                                style="width: 100%;"
                              ></el-date-picker>
                            </el-form-item>

                        </el-form-item>



                        <el-form-item label="状态">
                          <el-select clearable v-model="filters30.type" placeholder="请选择">
                            <el-option label="发货获得" :value="1"></el-option>
                            <el-option label="购买支出" :value="2"></el-option>
                            <el-option label="后台变动" :value="3"></el-option>
                          </el-select>
                        </el-form-item>

                        <el-form-item>
                          <el-button
                            type="primary"
                            @click="getLog()"
                          >搜索</el-button>

                        </el-form-item>

                      </el-form>
                    </div>
                  <div class="contain_body">
                    <el-table
                      v-loading="listLoading30"
                      :data="tableData30"
                      style="width: 100%"
                      :header-cell-class-name="objectSpanMethod"
                    >
                      <el-table-column
                        prop="username"
                        label="昵称"
                      >
                      </el-table-column>

                      <el-table-column
                        prop="telephone"
                        label="手机号"
                      >
                      </el-table-column>

                      <el-table-column
                        :formatter="formatterRoleType"
                        prop="roleType"
                        label="代理等级"
                      >
                      </el-table-column>

                      <el-table-column
                        prop="scorePrice"
                        label="积分"
                      >
                      </el-table-column>

                      <el-table-column
                        :formatter="formatterInfoType"
                        prop="infoType"
                        label="状态"
                      >
                      </el-table-column>

                      <el-table-column
                        prop="createTime"
                        label="时间"
                      >
                      </el-table-column>
                    </el-table>
                    <div class="pageDiv block">
                      <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChangeIntegra30"
                        :current-page.sync="page_num30"
                        :page-count="total_page30"
                        :page-size="page_size30"
                        layout="total, prev, pager, next"
                        :total="total_num30"
                      ></el-pagination>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <el-dialog title="订单详情" :visible.sync="subListVisible" width="50%">
      <div class="contain_body_head">购进商品列表</div>
      <el-table
        v-loading="subListLoading"
        :data="subList"
        style="width: 100%"
        :header-cell-class-name="objectSpanMethod"
      >
        <el-table-column prop="good_name" label="商品名称"></el-table-column>

        <el-table-column label="商品图片">
          <template slot-scope="scope">
            <img :src="scope.row.list_pic" style="width:50px;" />
          </template>
        </el-table-column>
        <el-table-column prop="good_price" label="原价"></el-table-column>

        <el-table-column prop="proxy_price" label="代理价"></el-table-column>

        <el-table-column prop="num" label="购买数量"></el-table-column>
      </el-table>
      <div style="height:10px;width:10px"></div>
      <div class="contain_body_head" v-show="buList.length > 0">补货商品列表</div>
      <div v-show="buList.length > 0">
        <div v-for="item in buList" v-bind:key="item.id">
          <div class="contain_body_head">{{item.order_code}},总金额：{{item.total_money}}元</div>
          <el-table
            v-loading="subListLoading"
            :data="item.sub"
            style="width: 100%"
            :header-cell-class-name="objectSpanMethod"
          >
            <el-table-column prop="good_name" label="商品名称"></el-table-column>

            <el-table-column label="商品图片">
              <template slot-scope="scope">
                <img :src="scope.row.list_pic" style="width:50px;" />
              </template>
            </el-table-column>
            <el-table-column prop="good_price" label="原价"></el-table-column>

            <el-table-column prop="proxy_price" label="代理价"></el-table-column>

            <el-table-column prop="num" label="购买数量"></el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="修改库存数量" :visible.sync="dialogEditVisible" width="20%">
      <el-form
        label-position="top"
        class="m-search"
        size="small"
        :model="editGoodNumForm"
        ref="editGoodNumForm"
      >
        <el-form-item label="类型" prop="type">
          <el-select v-model="editGoodNumForm.type" placeholder="请选择">
            <el-option label="加" value="1"></el-option>
            <el-option label="减" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数量" prop="goodNum">
          <el-input
            v-model="editGoodNumForm.goodNum"
            oninput="value=value.replace(/[^\d]/g,'')"
            placeholder="请输入整数"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="goodNum">
          <el-input v-model="editGoodNumForm.commend"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="throwGroupUp()" :loading="editNumLoading">提交</el-button>
          <el-button @click="dialogEditVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="积分变动" :visible.sync="dialogEditScoreVisible" width="20%">
      <el-form
        label-position="top"
        class="m-search"
        size="small"
        :model="editIntegralForm"
        ref="editIntegralForm"
      >
        <el-form-item label="积分" prop="score">
          <el-input type="number" v-model="editIntegralForm.score"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="doUpScore()" :loading="editNumLoading">提交</el-button>
          <el-button @click="dialogEditScoreVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="转为余额" :visible.sync="dialogEditIntegralVisible" width="20%">
      <el-form
        label-position="top"
        class="m-search"
        size="small"
        :model="editIntegralForm"
        ref="editIntegralForm"
      >
        <!-- <el-form-item label="学习积分" prop="integral">
          <el-input
            v-model="editIntegralForm.integral"
            oninput="value=value.replace(/[^\d]/g,'')"
            placeholder="请输入整数"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="学习积分" prop="integral">
          <el-input type="number" v-model="editIntegralForm.integral" @input="disPrice()"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="doUpBalance()" :loading="editNumLoading">提交</el-button>
          <el-button @click="dialogEditIntegralVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="释放保证金" :visible.sync="dialogEditRiskVisible" width="20%">
      <el-form
        label-position="top"
        class="m-search"
        size="small"
        :model="editRiskForm"
        ref="editRiskForm"
      >

        <el-form-item label="金额" prop="integral">
          <el-input type="number" v-model="editRiskForm.integral"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="doUpRisk()" :loading="editRiskLoading">提交</el-button>
          <el-button @click="dialogEditRiskVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="验证码" :visible.sync="dialogEditIntegralVisible1" width="400px">
      <div class="identity" style="margin-bottom: 20px">
        <el-input type="number" class="identity_input" v-model="identity"></el-input>
        <el-button style="height: 40px;line-height: 40px;padding: 0 20px;margin-left: 16px" type="primary" @click="startTime(true)" :loading="timeLoading">{{ time != 90 && !timeLoading ? time : '发送验证码' }}</el-button>
      </div>
      <div style="display: flex;align-items: center;justify-content: center">
        <el-button type="primary" @click="doUpIdentity()" :loading="editNumLoading">提交</el-button>
        <el-button style="margin-left: 30px" @click="dialogEditIntegralVisible1 = false">取消</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>

<script>
import { bus } from "../../bus.js";
import API from "../../api/api_user";
import { dateFunc } from "../../dateFunc.js";
export default {
  name: "user_detail",
  components: {},
  data() {
    return {
      followMap:{},
      goodInfo: null,
      editNumLoading: false,
      subListLoading: false,
      subListVisible: false,
      subListLoading: false,
      editGoodNumForm: {
        goodId: null,
        good_name: null,
        userId: null,
        commend: null,
        goodNum: null,
        type: "1",
        goodId: null
      },
      dialogEditVisible: false,
      infoType: null,
      inTotal: 0,
      outTotal: 0,
      rewardTotal: 0,
      listLoadingY: false,
      useTotal: 0,
      perMoneyDate: new Date(), //个人订单收益
      perSaleDate: new Date(), //个人订单销量
      perAcMoneyDate: new Date(), //个人活动订单收益
      perAcSaleDate: new Date(), //个人活动订单销量
      groupMoneyDate: new Date(), //团队订单收益
      groupSaleDate: new Date(), //团队订单销量
      groupAcMoneyDate: new Date(), //团队活动订单收益
      groupAcSaleDate: new Date(), //团队活动订单销量
      groupCount: {},
      listLoadingOut: false,
      tableDataOut: [],
      filtersIn: {
        startTime: null,
        endTime: null,
        status: null
      },
      filtersOut: {
        startTime: null,
        endTime: null,
        status: null
      },
      yejiMap: {},
      filtersY: {
        month: null,
        type: null
      },
      tableData4: [],
      tableData91: [],
      filtersOrder: {
        startTime: null,
        endTime: null,
        type: null,
        status: null,
      },
      filtersOrderRisk: {
        startTime: null,
        endTime: null,
        type: null,
        status: null,
      },
      filtersReward: {
        startTime: null,
        orderType: "1",
        endTime: null
      },
      tableDataGroup: [],
      page_num: 1,
      keywords: "",
      total_num: 0,
      total_page: 0,
      page_size: 10,
      listLoading1: false,
      listLoading2: false,
      listLoading3: false,

      page_num1Y: 1,
      total_num1Y: 0,
      total_page1Y: 0,
      page_size1Y: 10,
      tableDataY: [],

      page_num11: 1,
      total_num11: 0,
      total_page11: 0,
      page_size11: 10,

      page_num31: 1,
      total_num31: 0,
      total_page31: 0,
      page_size31: 10,
      listLoading31:false,
      tableDataGroup31:[],
      page_num5: 1,
      total_num5: 0,
      total_page5: 0,
      page_size5: 10,
      page_num4: 1,
      total_num4: 0,
      total_page4: 0,
      page_size4: 10,
      page_num3: 1,
      total_num3: 0,
      total_page3: 0,
      page_size3: 10,


      page_num91: 1,
      total_num91: 0,
      total_page91: 0,
      page_size91: 10,

      page_num2: 1,
      total_num2: 0,
      total_page2: 0,
      page_size2: 100,

      listLoading255: false,

      page_num3G: 1,
      total_num3G: 0,
      total_page3G: 0,
      page_size3G: 10,
      tableData2G: [],

      page_num3: 1,
      total_num3: 0,
      total_page3: 0,
      page_size3: 10,

      page_num1: 1,
      total_num1: 0,
      total_page1: 0,
      page_size1: 10,
      value1: null,
      CourseGrades: [],
      highScools: [],
      baseFormRule: {},
      filters: {
        status: null,
        startTime: null,
        userId: null,
        endTime: null
      },
      groupMap: {},
      filtersGroup: {
        type: "1",
        roleType: null,
        status:null,
        username: null,
        subId: null
      },
      baseForm: {
        sex: "1",
        username: null,
        fromSchool: null,
        grade: null,
        birthdayTime1: null,
        idCode: null,
        wechatCode: null,
        nation: null,
        fromSchoolClassName: null,
        qqCode: null,
        livePlace: null,
        commend: null
      },
      loading: false,
      tels: [
        {
          name: "联系电话",
          remark: "",
          term: ""
        }
      ],

      dialogFollow: false,
      othSchools: [],
      othSchools1: null,
      powers: "",
      stu: null,
      userId: null,
      username: null,
      img: null,
      // img: require("../../assets/img/head.png"),
      num1: 0,
      tags: [
        { index: 0, name: "拉丁舞", id: 0, status: true },
        { index: 1, name: "素描画", id: 1, status: false },
        { index: 2, name: "民族舞", id: 2, status: true }
      ],
      activeName: "yeji",
      bankListVisible: false,
      tableData33: [],
      bankListVisibleLoading: false,
      tableData: [],
      addVisibleLoading: false,
      tableData2: [],
      tableData1: [],
      countInfo: {},
      orderData: [],
      recordData: [],
      AchieveData: [],
      folderData: [],
      listLoading: false,
      accountData: [],
      tel: null,
      relation: null,
      backType:null,
      subList: [],
      buList: [],
      remain_money: null,
      editRiskLoading:false,
      backNum: null,
      editRiskForm: {
        integral: 0,
        score: 0,
      },
      get_group_user_countLoading: false,
      dialogEditIntegralVisible: false,
      dialogEditRiskVisible:false,
      dialogEditIntegralVisible1: false,
      editIntegralForm: {
        integral: 0,
        score: 0,
      },
      page_num20: 1,
      total_num20: 0,
      total_page20: 0,
      page_size20: 10,
      listLoading20: false,
      tableData20: [],
      identity: '',
      time: 90,
      setInterval1: '',
      integralMap: {},
      timeLoading: false,
      temporaryPrice: null,
      temporaryIdentity: null,
      infoTypeList: [
        {
          label: "批发采购",
          value: 1
        },
        {
          label: "批发销售",
          value: 2
        },
        {
          label: "充值",
          value: 3
        },
        {
          label: "转账",
          value: 4
        },
        {
          label: "红包",
          value: 5
        },
        {
          label: "接单收入",
          value: 6
        },
        {
          label: "接单退回",
          value: 7
        },
        {
          label: "公司返款",
          value: 8
        },
        {
          label: "保证金",
          value: 9
        },
        {
          label: "后台充值",
          value: 10
        },
        {
          label: "提现",
          value: 11
        },
        {
          label: "后台扣款",
          value: 12
        },
        {
          label: "奖励",
          value: 72
        },
        {
          label: "学习积分",
          value: 67
        },
        {
          label: "换货",
          value: 68
        },
      ],
      statusList: [],
      showStatus: false,
      tableData30: [],
      listLoading30: false,
      page_num30: 1,
      total_num30: 0,
      total_page30: 0,
      page_size30: 10,
      filters30: {
        userId: null,
        startTime: null,
        endTime: null,
        userKeyword: null,
        userType: null,
        type: null,
      },
      dialogEditScoreVisible: false,
    };
  },
  created() {
    var that = this;
    var id = ""
    if (this.$route.query.id) {
      id = this.$route.query.id;
      localStorage.setItem('userDetailId', this.$route.query.id)
    } else {
      id = localStorage.getItem('userDetailId')
    }
    if (this.$route.query.back && this.$route.query.back != null)
    {
      this.backType = this.$route.query.back;
    }
    this.userId = id;
    API.get_group_user_info({
      token: localStorage.getItem("api_token"),
      userId: id
    })
      .then(
        function(result) {
          that.addLoading = false;
          if (result.key == 1000) {
            that.stu = result.result.map;
            if (that.stu.open_status == 1)
            {
              that.stu.open_status1 = '创建会员';
            } else if (that.stu.open_status == 2)
            {
              that.stu.open_status1 = '已绑定手机号';
            } else if (that.stu.open_status == 3)
            {
              that.stu.open_status1 = '已实名';
            } else if (that.stu.open_status == 4)
            {
              that.stu.open_status1 = '已签约';
            }
            that.stu.create_time = dateFunc.formatDate(
              new Date(parseInt(that.stu.create_time)),
              "yyyy-MM-dd hh:mm:ss"
            );

            if (that.activeName == "yeji") {
              that.handleSearchYeji();
            } else if (that.activeName == "cangku") {
              that.handleSearchGoodList();
            } else if (that.activeName == "second") {
              // this.get_group_user_count();
            } else if (that.activeName == "four_ua") {
              that.selectAddress();
            } else if (that.activeName == "third") {
              that.selectBank();
            } else if (that.activeName == "three") {
              that.handleSearchIn();
            } else if (that.activeName == "four") {
              that.handleSearch();
            } else if (that.activeName == "fifth") {
              that.handleSearchOrder();
              // 订单消费记录;
            }
            else if (that.activeName == "riskPane") {
              that.handleSearchRiskOrder();
              // 订单消费记录;
            }

            else if (that.activeName == "six") {
              that.handleSearchReward();
              // 打赏记录;
            } else if (that.activeName == "seven") {
              that.handleSearchGroup(); //我的团队
            } else if (that.activeName == "integral") {
              that.handleSearchIntegralHistory(); //积分明细
            } else if (that.activeName == "mm_fuww") {
              that.handleSearchFollow(); //档案信息
            }
          } else {
            that.$message.error({
              showClose: true,
              message: result.message || "登录失败",
              duration: 2000
            });
          }
        },
        function(err) {
          that.loading = false;
          console.error(err);
          that.$message.error({
            showClose: true,
            message: err.toString(),
            duration: 2000
          });
        }
      )
      .catch(function(error) {
        that.loading = false;
        console.error(error);
        that.$message.error({
          showClose: true,
          message: "请求出现异常",
          duration: 2000
        });
      });
    //cangku
  },
  mounted() {
    this.activityId = this.$route.query.acId;
    this.activityName = this.$route.query.acName;
  },
  methods: {
    handleCurrentChangeIntegra30(){
      this.getLog()
    },
    getLog(){
      let that = this;
      that.listLoading30 = true;
      let para = {
        token: localStorage.getItem("api_token"),
        pageNum: that.page_num30,
        pageSize: that.page_size30,
        userId:this.userId
      };
      if(that.filters30.startTime){
        para.startTime = that.filters30.startTime.getTime()
      }
      if(that.filters30.endTime){
        para.endTime = that.filters30.endTime.getTime()
      }
      if(that.filters30.userType){
        para.userType = that.filters30.userType
      }
      if(that.filters30.type){
        para.type = parseInt(that.filters30.type)
      }
      if(that.filters30.userKeyword){
        para.userKeyword = that.filters30.userKeyword
      }
      API.send_score_history_list(para)
        .then(
          function(result) {
            if (result && parseInt(result.key) === 1000) {
              that.total_num30 = result.result.count;
              that.total_page30 = result.result.allPageNumber;
              if (result.result.list != null && result.result.list.length > 0) {
                for(var i = 0;i<result.result.list.length;i++){
                  result.result.list[i].createTime = dateFunc.formatDate(
                      new Date(parseInt(result.result.list[i].createTime)),
                      "yyyy-MM-dd hh:mm:ss"
                    );
                }
                that.tableData30 = result.result.list;
              } else {
                that.tableData30 = [];
              }
              that.listLoading30 = false
            }
          },
          function(err) {
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    formatterInfoType(row, column){
      var word = "--";
      if(row.infoType == 1){
        word = "发货获得";
      }else if(row.infoType == 2){
        word = "购买支出";
      }else if(row.infoType == 3){
        word = "后台变动";
      }
      return word;
    },
    changeInfoType(e){
      var value = []
      switch(e){
        case 1: //批发采购
          value = [
            {
              label: "结算中",
              value: 11,
            },
            {
              label: "已完成",
              value: 12,
            },
          ];
          break;
        case 2: //批发销售
          value = [
            {
              label: "已完成",
              value: 21,
            },
          ];
          break;
        case 3: //充值
          value = [
            {
              label: "充值成功",
              value: 32,
            },
          ];
          break;
        case 4: //转账
          value = [
            {
              label: "转出",
              value: 41,
            },
            {
              label: "转入",
              value: 42,
            },
          ];
          break;
        case 5: //红包
          value = [
            {
              label: "转入",
              value: 51,
            },
            {
              label: "转出",
              value: 52,
            },
          ];
          break;
        case 6: //接单收入
          value = [
            {
              label: "已完成",
              value: 61,
            },
          ];
          break;
        case 7: //接单退回
          value = [
            {
              label: "已完成",
              value: 71,
            },
          ];
          break;
        case 8: //公司返款
          value = [
            {
              label: "已完成",
              value: 81,
            },
          ];
          break;
        case 9: //保证金
          value = [
            {
              label: "增加保证金-已完成",
              value: 91,
            },
            {
              label: "扣除保证金-已完成",
              value: 92,
            },
          ];
          break;
        case 10: //后台充值
          value = [
            {
              label: "已完成",
              value: 101,
            },
          ];
          break;
        case 11: //提现
          value = [
            {
              label: "申请中",
              value: 111,
            },
            {
              label: "已完成",
              value: 112,
            },
            {
              label: "提现失败",
              value: 113,
            },
          ];
          break;
        case 12: //后台扣款
          value = [
            {
              label: "扣款完成",
              value: 121,
            },
          ];
          break;
        case 72: //奖励
          value = [
            {
              label: "个人奖励-已完成",
              value: 721,
            },
            {
              label: "目标奖励-已完成",
              value: 722,
            },
            {
              label: "释放个人奖励-已完成",
              value: 723,
            },
            {
              label: "释放目标奖励-已完成",
              value: 724,
            },
            {
              label: "直属奖励-已完成",
              value: 725,
            },
            {
              label: "释放直属奖励-已完成",
              value: 726,
            },
            {
              label: "释放推荐奖励-已完成",
              value: 727,
            },
          ];
          break;
        case 67: //学习积分
          value = [
            {
              label: "购买",
              value: 671,
            },
            {
              label: "转为余额",
              value: 672,
            },
          ];
          break;
        case 68: //换货
          value = [
            {
              label: "已完成",
              value: 681,
            },
          ];
          break;
        default:
          value = [];
      }
      if(value.length > 0){
        this.showStatus = true
        this.filtersOrder.status = null
      }else{
        this.showStatus = false
      }
      this.statusList = value
    },
    disPrice () {
      let priceVal = this.editIntegralForm.integral
      var reg =  /^(([0-9]+)|([0-9]+\.[0-9]{0,2}))$/;
      if (reg.test(priceVal)) {
        this.temporaryPrice = priceVal
      } else {
        if (this.temporaryPrice.length == 1 ) {
          this.editIntegralForm.integral = ''
        } else {
          this.editIntegralForm.integral = this.temporaryPrice
        }
      }
    },
    doUpRisk()
    {

      let that = this
      if(that.editRiskForm.integral <= 0){
        that.$message.error({
          showClose: true,
          message: "输入积分必须大于0",
          duration: 2000
        });
        return;
      }
      that.editRiskLoading = true
      let params = {
        token: localStorage.getItem("api_token"),
        userId: that.$route.query.id,
        integral: that.editRiskForm.integral
      }
      API.out_risk_m(params)
        .then(
          function(result) {
            that.editRiskLoading = false;
            if (result && parseInt(result.key) === 1000) {
              that.stu.execPrice = that.stu.execPrice - that.editRiskForm.integral
              that.dialogEditRiskVisible = false
              that.$message.success({
                showClose: true,
                message: "提交成功",
                duration: 2000
              });
            }else{
              that.$message.error({
                showClose: true,
                message: result.message.toString(),
                duration: 2000
              });
            }
          },
          function(err) {
            that.editRiskLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.editRiskLoading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    doUpIdentity () {
      let that = this;
      let params = {
        token: localStorage.getItem("api_token"),
        orderCode: this.integralMap.myCode,
        identity: this.identity
      };
      API.t_check_pay_identify(params)
        .then(
          function(result) {
            if (result.key == 1000) {
              that.stu.integral = that.stu.integral - that.editIntegralForm.integral
              that.stu.balance = parseFloat(that.stu.balance) + parseFloat(that.editIntegralForm.integral)
              that.dialogEditIntegralVisible1 = false
              that.identity = ""
              that.time = 1
              that.$message.success({
                showClose: true,
                message: "提交成功",
                duration: 2000
              });
            } else {
              that.$message.error({
                showClose: true,
                message: result.message || "请求失败",
                duration: 2000
              });
            }
          },
          function(err) {
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    startIdentity () {
      let that = this;
      let params = {
        token: localStorage.getItem("api_token"),
        orderCode: this.integralMap.myCode
      };
      API.t_r_send_identify(params)
        .then(
          function(result) {
            if (result.key == 1000) {
              // that.startTime()
              that.time = 89
              that.timeLoading = false
              that.$message.success({
                showClose: true,
                message: "发送验证码成功",
                duration: 1500
              });
            } else {
              clearInterval(that.setInterval1)
              that.time = 90
              that.timeLoading = false
            }
          },
          function(err) {
            clearInterval(that.setInterval1)
            that.time = 90
            that.timeLoading = false
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          clearInterval(that.setInterval1)
          that.time = 90
          that.timeLoading = false
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    startTime (isFirst) {
      if (this.time != 90) return
      clearInterval(this.setInterval1)
      this.time = 89
      this.setInterval1 = setInterval(() => {
        if (this.time < 0 || this.time == 0) {
          clearInterval(this.setInterval1)
          this.time = 90
        } else {
          this.time -= 1
        }
      }, 1000)
      if (isFirst) {
        this.timeLoading = true
        this.startIdentity()
      }
    },
    handleCurrentChangeIntegral(val) {
      this.searchIntegralHistory();
    },
    handleSearchIntegralHistory(){
      this.page_size20 = 10;
      this.page_num20 = 1;
      this.searchIntegralHistory();
    },
    searchIntegralHistory() {
      let that = this;
      let params = {
        pageNum: that.page_num20,
        pageSize: that.page_size20,
        userId: this.userId,
        token: localStorage.getItem("api_token")
      };
      that.listLoading20 = true;
      API.user_integral_history_list(params)
        .then(
          function(result) {
            that.listLoading20 = false;
            if (result.key == 1000) {
              that.total_num20 = result.result.count;
              that.total_page20 = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
                for (var i = 0; i < result.result.list.length; i++) {
                  result.result.list[i].create_time = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].createTime)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
                  result.result.list[i].infoTypeName = result.result.list[i].infoType == 1 ? '加' : '减'
                }
              }
              that.tableData20 = result.result.list;
            }
          },
          function(err) {
            that.listLoading20 = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.listLoading20 = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    doUpBalance(){
      let that = this
      if(that.editIntegralForm.integral <= 0){
        that.$message.error({
          showClose: true,
          message: "输入积分必须大于0",
          duration: 2000
        });
        return;
      }
      that.editNumLoading = true
      let params = {
        token: localStorage.getItem("api_token"),
        userId: that.$route.query.id,
        integral: that.editIntegralForm.integral
      }
      API.integral_change_balance(params)
        .then(
          function(result) {
            that.editNumLoading = false;
            if (result && parseInt(result.key) === 1000) {
              that.integralMap = result.result.map
              that.dialogEditIntegralVisible = false
              that.dialogEditIntegralVisible1 = true
              that.startTime(false)
              that.$message.success({
                showClose: true,
                message: "提交成功",
                duration: 2000
              });
            }else{
              that.$message.error({
                showClose: true,
                message: result.message.toString(),
                duration: 2000
              });
            }
          },
          function(err) {
            that.editNumLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.editNumLoading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    doUpScore(){
      let that = this
      var s = that.stu.sendScore
      that.editNumLoading = true
      let params = {
        token: localStorage.getItem("api_token"),
        userId: that.userId,
        price: that.editIntegralForm.score
      }
      API.up_user_send_score(params)
        .then(
          function(result) {
            that.editNumLoading = false;
            if (result && parseInt(result.key) === 1000) {
              that.dialogEditScoreVisible = false
              var score = parseFloat(parseFloat(s) + parseFloat(that.editIntegralForm.score)).toFixed(2)
              that.stu.sendScore = score
              that.$message.success({
                showClose: true,
                message: "提交成功",
                duration: 2000
              });
            }else{
              that.$message.error({
                showClose: true,
                message: result.message.toString(),
                duration: 2000
              });
            }
          },
          function(err) {
            that.editNumLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.editNumLoading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    showScoreHistory(){
      let that = this
      that.dialogEditScoreVisible = true
      that.editIntegralForm.score = 0
    },
    showIntegralHistory(){
      let that = this
      that.dialogEditIntegralVisible = true
      that.editIntegralForm.integral = 0
      clearInterval(this.setInterval1)
      this.time = 90
    },
    showRiskSet(){
      let that = this
      that.dialogEditRiskVisible = true
      that.editRiskForm.integral = 0
    },
    showOrderDetail(row) {
      let that = this;
      that.subListVisible = true;
      that.subListLoading = true;
      let para = {
        token: localStorage.getItem("api_token"),
        id: row.id
      };
      API.good_order_detail(para)
        .then(
          function(result) {
            that.subListLoading = false;
            if (result && parseInt(result.key) === 1000) {
              that.subList = result.result.map.sub;
              if (result.result.map.orders != null) {
                that.buList = result.result.map.orders;
              } else {
                that.buList = [];
              }
            }
          },
          function(err) {
            that.subListLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.subListLoading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },

    showTBalance1(user_type) {
      let that = this;
      let para = {
        token: localStorage.getItem("api_token"),
        userId: this.userId
      };
      API.get_group_user_t_info(para)
        .then(
          function(result) {
            that.subListLoading = false;
            if (result && parseInt(result.key) === 1000) {
              if (result.result.map != null)
              {
                if (user_type == 1)
                {
                  var isPhoneChecked =
                that.$notify({
                  title: '通联信息绑定状态',
                  message: '绑定手机：' + result.result.map.isPhoneChecked + '；实名认证：' + result.result.map.isIdentityChecked + '；电子签约：' + result.result.map.isSignContract,
                  duration: 0
                });
                } else{
                  var ocrIdcardComparisonResult = result.result.map.ocrIdcardComparisonResult && result.result.map.ocrIdcardComparisonResult != null ? (result.result.map.ocrIdcardComparisonResult == 1 ? '是':'否') : '无';
                  var ocrRegnumComparisonResult = result.result.map.ocrRegnumComparisonResult && result.result.map.ocrRegnumComparisonResult != null ? (result.result.map.ocrRegnumComparisonResult == 1 ? '是':'否') : '无';
                  var status =  '无';
                  if (result.result.map.status && result.result.map.status != null)
                  {
                    if (result.result.map.status == 1)
                    {
                      status = '待审核';
                    } else if (result.result.map.status == 2)
                    {
                      status = '审核通过';
                    } else if (result.result.map.status == 3)
                    {
                      status = '审核失败';
                    }
                  }
                  var isPhoneChecked =
                that.$notify({
                  title: '通联信息绑定状态',
                  message: '绑定手机：' + result.result.map.isPhoneChecked +'企业基本信息：' + status +  '；企业工商认证信息：' + ocrRegnumComparisonResult + '；企业法人实名信息：' + ocrIdcardComparisonResult + '；电子签约：' + result.result.map.isSignContract,
                  duration: 0
                });
                }
              }
            }
          },
          function(err) {
            that.subListLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.subListLoading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    showTBalance() {
      let that = this;
      let para = {
        token: localStorage.getItem("api_token"),
        userId: this.userId
      };
      API.get_group_user_t_ba(para)
        .then(
          function(result) {
            that.subListLoading = false;
            if (result && parseInt(result.key) === 1000) {
              if (result.result.map != null)
              {
                that.$notify({
                  title: '通联余额',
                  message: '余额：' +  (result.result.map.allAmount / 100).toFixed(2) + '；冻结金额：' + result.result.map.freezenAmount,
                  duration: 0
                });
              }
            }
          },
          function(err) {
            that.subListLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.subListLoading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    addStock() {
      this.$router.push({
        path: "/userStockAdd",
        query: { userId: this.userId }
      });
    },
    showEditForm(row) {
      this.editGoodNumForm.type = "1";
      this.editGoodNumForm.goodNum = 0;
      this.editGoodNumForm.goodId = row.good_id;
      this.editGoodNumForm.good_name = row.good_name;
      this.dialogEditVisible = true;
    },
    throwGroupUp() {
      var that = this;
      if (!that.editGoodNumForm.type || that.editGoodNumForm.type == null) {
        that.$message.error({
          showClose: true,
          message: "请选择操作类型",
          duration: 2000
        });
      } else if (
        !that.editGoodNumForm.goodNum ||
        that.editGoodNumForm.goodNum == null
      ) {
        that.$message.error({
          showClose: true,
          message: "请输入操作数量",
          duration: 2000
        });
      } else {
        that.editNumLoading = true;
        let para = {
          token: localStorage.getItem("api_token"),
          userId: that.userId,
          op_time: new Date().getTime(),
          goods: JSON.stringify([
            {
              infoId: that.editGoodNumForm.goodId,
              goodNum: that.editGoodNumForm.goodNum,
              commend: that.editGoodNumForm.commend,
              title: that.editGoodNumForm.good_name
            }
          ]),
          type: that.editGoodNumForm.type
        };
        API.add_user_stock(para)
          .then(
            function(result) {
              that.editNumLoading = false;
              if (result && parseInt(result.key) === 1000) {
                that.$message.success({
                  showClose: true,
                  message: "申请成功",
                  duration: 1500
                });
                that.dialogEditVisible = false;
                that.searchGoodList();
              }
            },
            function(err) {
              that.editNumLoading = false;
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }
          )
          .catch(function(error) {
            that.editNumLoading = false;
            console.log(error);
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
      }
    },
    formatterOrderType(row, column) {
      if (row.order_type == 1) {
        return "发货订单";
      } else if (row.order_type == 2) {
        return "购进订单";
      } else if (row.order_type == 3) {
        return "待补货订单";
      } else if (row.order_type == 4) {
        return "已补货订单";
      }
    },
    formatterUserStatus(row, column) {
      if (row.status == 1) {
        return "正常";
      } else if (row.status == 2) {
        return "禁用";
      }
    },
    formatterRoleType(row, column) {
      if (row.roleType == -1) {
        return "无";
      } else if (row.roleType == -0.5) {
        return "康减系列vip会员";
      } else if (row.roleType == -0.4) {
        return "康减系列高级会员";
      } else if (row.roleType == -0.3) {
        return "康减系列荣誉会员";
      } else if (row.roleType == 0) {
        return "VIP门店";
      } else if (row.roleType == 1) {
        return "联盟店";
      } else if (row.roleType == 2) {
        return "市代";
      } else if (row.roleType == 3) {
        return "省代";
      } else if (row.roleType == 4) {
        return "CEO";
      } else if (row.roleType == 1.1) {
        return "康减系列市代";
      } else if (row.roleType == 2.1) {
        return "康减系列省代";
      } else if (row.roleType == 3.1) {
        return "康减系列CEO";
      } else if (row.roleType == 1.05) {
        return "优秀联盟店";
      } else if (row.roleType == 5) {
        return "总经销商";
      } else if (row.roleType == 2.2) {
        return "合伙人";
      } else if (row.roleType == 4.2) {
        return "董事";
      } else if (row.roleType == 5.1) {
        return "区域总监";
      } else if (row.roleType == 5.2) {
        return "城市加盟商";
      } else if (row.roleType == 4.8) {
        return "经销商";
      }
    },
    hasPower(power) {
      let powers = localStorage.getItem("powers");
      powers = JSON.parse(powers);
      var has = false;
      for (var i = 0; i < powers.length; i++) {
        if (powers[i] == power) {
          has = true;
          break;
        }
      }
      return has;
    },
    excelOut() {
      var that = this;
      var url =
        "/manager/user/pc/my_group_excel?token=" +
        localStorage.getItem("api_token");
      url = url + "&userId=" + this.userId;
      if (that.filtersGroup.type) {
        url = url + "&type=" + that.filtersGroup.type;
      }
      if (that.filtersGroup.username) {
        url = url + "&username=" + that.filtersGroup.username;
      }
      if (that.filtersGroup.roleType) {
        url = url + "&roleType=" + that.filtersGroup.roleType;
      }
      if (that.filtersGroup.status) {
        url = url + "&status=" + that.filtersGroup.status;
      }
      top.location.href = url;
    },
    excelOutOSix() {
      var that = this;
      var url =
        "/manager/user/pc/trial_list_excel?token=" +
        localStorage.getItem("api_token");
      url = url + "&userId=" + this.userId;
      if (that.filtersOrder.type) {
        url = url + "&type=" + that.filtersOrder.type;
      }
      if (that.filtersOrder.startTime) {
        url = url + "&startTime=" + that.filtersOrder.startTime.getTime();
      }
      if (that.filtersOrder.endTime) {
        url = url + "&endTime=" + that.filtersOrder.endTime.getTime();
      }
      if (that.filtersGroup.status) {
        url = url + "&status=" + that.filtersGroup.status;
      }
      top.location.href = url;
    },

    excelOut2() {
      var that = this;
      var url =
        "/manager/user/pc/normal_user_stock_list_excel?token=" +
        localStorage.getItem("api_token");
      url = url + "&normal_user_id=" + this.userId;

      // window.open("http://localhost:8839"+url,'_blank')
      top.location.href = url;
    },
    upHouseStatus(row, status) {
      if (status == 3) {
        let that = this;
        this.$confirm("确定拒绝吗?", "提示", { type: "info" })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              inId: row.id,
              status: 3
            };
            API.up_charge(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "拒绝成功",
                      duration: 1500
                    });
                    that.searchIn();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      } else if (status == 2) {
        let that = this;
        this.$confirm("确定通过该审核吗?", "提示", { type: "info" })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              inId: row.id,
              status: 2
            };
            API.up_charge(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "通过成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      }
    },
    upHouseStatusOut(row, status) {
      if (status == 3) {
        let that = this;
        this.$confirm("确定拒绝吗?", "提示", { type: "info" })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              outId: row.id,
              status: 3
            };
            API.up_cash_out(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "拒绝成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      } else if (status == 2) {
        let that = this;
        this.$confirm("确定通过该审核吗?", "提示", { type: "info" })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              outId: row.id,
              status: 2
            };
            API.up_cash_out(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "通过成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      }
    },
    formatterOrderStatus(row, column) {
      if (row.status == 1) {
        return "待支付";
      } else if (row.status == 2) {
        return "待发货";
      } else if (row.status == 3) {
        return "待收货";
      } else if (row.status == 4) {
        return "已完成";
      } else if (row.status == 5) {
        return "已取消";
      } else if (row.status == 7) {
        return "待自提";
      } else if (row.status == 8) {
        return "已自提";
      } else if (row.status == 9) {
        return "待补货";
      } else if (row.status == 10) {
        return "待支付";
      } else if (row.status == 11) {
        return "已完成";
      } else if (row.status == 12) {
        return "补货已过期";
      }
    },
    formatterGroupType(row, column) {
      if (row.group_type == 1) {
        return "初级管家";
      } else if (row.group_type == 2) {
        return "中级管家";
      } else if (row.group_type == 3) {
        return "高级管家";
      }
    },
    get_group_user_count(type) {},

    selectAddress() {
      this.bankListVisible = true;
      let that = this;
      let params = {
        token: localStorage.getItem("api_token"),
        userId: this.userId
      };
      that.addVisibleLoading = true;
      API.user_address_list(params)
        .then(
          function(result) {
            that.addVisibleLoading = false;
            if (result.key == 1000) {
              that.tableData33 = result.result.list;
            }
          },
          function(err) {
            that.addVisibleLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.addVisibleLoading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },

    selectBank() {
      this.bankListVisible = true;
      let that = this;
      let params = {
        token: localStorage.getItem("api_token"),
        userId: this.userId,
        status: 1
      };
      that.bankListVisibleLoading = true;
      API.user_bank_list(params)
        .then(
          function(result) {
            that.bankListVisibleLoading = false;
            if (result.key == 1000) {
              that.tableData1 = result.result.list;
            }
          },
          function(err) {
            that.bankListVisibleLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.bankListVisibleLoading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },

    handleSearch() {
      this.page_size11 = 10;
      this.page_num11 = 1;
      this.search();
    },
    search() {
      let that = this;
      let params = {
        userId: this.userId,
        pageNum: that.page_num11,
        pageSize: that.page_size11,
        token: localStorage.getItem("api_token")
      };
      if (that.filtersOut.status) {
        params.status = that.filtersOut.status;
      }
      if (that.filtersOut.startTime) {
        params.startTime = that.filtersOut.startTime.getTime();
      }
      if (that.filtersOut.endTime) {
        params.endTime = that.filtersOut.endTime.getTime();
      }
      that.listLoadingOut = true;
      API.money_out_list(params)
        .then(
          function(result) {
            that.listLoadingOut = false;
            if (result.key == 1000) {
              that.total_num11 = result.result.count;
              that.total_page11 = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
                for (var i = 0; i < result.result.list.length; i++) {
                  if (result.result.list[i].cash_rate != null) {
                    result.result.list[i].total_money =
                      result.result.list[i].pay_money *
                      (1 - result.result.list[i].cash_rate);
                    result.result.list[i].rate_money =
                      result.result.list[i].pay_money *
                      result.result.list[i].cash_rate;
                  } else {
                    result.result.list[i].total_money =
                      result.result.list[i].pay_money;
                    result.result.list[i].rate_money = 0;
                  }
                }
              }
              that.tableDataOut = result.result.list;
              that.outTotal = result.result.data;
            }
          },
          function(err) {
            that.listLoadingOut = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.listLoadingOut = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },

    yejiCount() {
      let that = this;
      let params = {
        userId: this.userId,
        code: this.stu.recommend_code,
        roleType: this.stu.role_type,
        type: this.filtersY.type,
        month: dateFunc.formatDate(this.filtersY.month, "yyyy-MM"),
        token: localStorage.getItem("api_token")
      };
      API.sale_count_total(params)
        .then(
          function(result) {
            if (result.key == 1000) {
              that.yejiMap = result.result.map;
            }
          },
          function(err) {
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.listLoadingY = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },

    handleSearchYeji() {
      this.page_size1Y = 10;
      this.page_num1Y = 1;
      if (!this.filtersY.type && this.filtersY.type == null) {
        this.filtersY.type = "1";
      }
      if (this.filtersY.month == null) {
        this.filtersY.month = new Date();
      }
      this.yejiCount();
      this.searchYeji();
    },
    searchYeji() {
      let that = this;
      let params = {
        userId: this.userId,
        month: dateFunc.formatDate(this.filtersY.month, "yyyy-MM"),
        type: this.filtersY.type,
        roleType: this.stu.role_type,
        code: this.stu.recommend_code,
        pageNum: that.page_num1Y,
        oldUpId: this.stu.old_up_id,
        pageSize: that.page_size1Y,
        token: localStorage.getItem("api_token")
      };
      that.listLoadingY = true;
      API.sale_count_list(params)
        .then(
          function(result) {
            that.listLoadingY = false;
            if (result.key == 1000) {
              that.total_num1Y = result.result.count;
              that.total_page1Y = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
              }
              that.tableDataY = result.result.list;
            }
          },
          function(err) {
            that.listLoadingY = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.listLoadingY = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },

    handleSearchIn() {
      this.page_size1 = 10;
      this.page_num1 = 1;
      this.searchIn();
    },
    searchIn() {
      let that = this;
      let params = {
        userId: this.userId,
        pageNum: that.page_num1,
        pageSize: that.page_size1,
        token: localStorage.getItem("api_token")
      };
      if (that.filtersIn.status) {
        params.status = that.filtersIn.status;
      }
      if (that.filtersIn.startTime) {
        params.startTime = that.filtersIn.startTime.getTime();
      }
      if (that.filtersIn.endTime) {
        params.endTime = that.filtersIn.endTime.getTime();
      }

      that.listLoading = true;
      API.money_in_list(params)
        .then(
          function(result) {
            that.listLoading = false;
            if (result.key == 1000) {
              that.total_num1 = result.result.count;
              that.total_page1 = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
                // for (var i=0; i<result.list.length; i++)
                // {
                //   result.list[i].properties =
                // }
              }
              that.tableData = result.result.list;
              that.inTotal = result.result.data;
            }
          },
          function(err) {
            that.listLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.listLoading = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    handleSearchOrder() {
      this.page_size5 = 10;
      this.page_num5 = 1;
      this.searchOrder();
    },

    handleSearchRiskOrder() {
      this.page_size91 = 10;
      this.page_num91 = 1;
      this.searchRIskOrder();
    },
    searchRIskOrder() {
      let that = this;
      let params = {
        pageNum: that.page_num91,
        pageSize: that.page_size91,
        userId: this.userId,
        token: localStorage.getItem("api_token")
      };
      if (that.filtersOrderRisk.startTime) {
        params.startTime = that.filtersOrderRisk.startTime.getTime();
      }
      if (that.filtersOrderRisk.endTime) {
        params.endTime = that.filtersOrderRisk.endTime.getTime();
      }
      if(that.filtersOrderRisk.type){
        params.type = that.filtersOrderRisk.type
      }
      that.listLoading4 = true;
      API.risk_op_list(params)
        .then(
          function(result) {
            that.listLoading4 = false;
            if (result.key == 1000) {
              that.total_num91 = result.result.count;
              that.total_page91 = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
                for (var i = 0; i < result.result.list.length; i++) {
                  result.result.list[i].create_time = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].create_time)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
                  if (result.result.list[i].op_type == 1) {
                    result.result.list[i].op_type = "增加";

                  } else if (result.result.list[i].op_type == 2) {
                    result.result.list[i].op_type = "释放";

                  }
                }
              }
              that.tableData91 = result.result.list;
            }
          },
          function(err) {
            that.listLoading4 = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.listLoading4 = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    searchOrder() {
      let that = this;
      let params = {
        pageNum: that.page_num5,
        pageSize: that.page_size5,
        type: that.filtersOrder.type,
        userId: this.userId,
        token: localStorage.getItem("api_token")
      };
      if (that.filtersOrder.startTime) {
        params.startTime = that.filtersOrder.startTime.getTime();
      }
      if (that.filtersOrder.endTime) {
        params.endTime = that.filtersOrder.endTime.getTime();
      }
      if(that.filtersOrder.status){
        params.status = that.filtersOrder.status
      }
      that.listLoading4 = true;
      API.trial_list(params)
        .then(
          function(result) {
            that.listLoading4 = false;
            if (result.key == 1000) {
              that.total_num5 = result.result.count;
              that.total_page5 = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
                for (var i = 0; i < result.result.list.length; i++) {
                  result.result.list[i].create_time = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].create_time)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
                  if (result.result.list[i].info_type == 1) {
                    result.result.list[i].info_type = "批发采购";
                    if (result.result.list[i].status == 11) {
                      result.result.list[i].status = "结算中";
                    } else {
                      result.result.list[i].status = "已完成";
                    }
                  } else if (result.result.list[i].info_type == 2) {
                    result.result.list[i].info_type = "批发销售";
                    if (result.result.list[i].status == 21) {
                      result.result.list[i].status = "已完成";
                    }
                  } else if (result.result.list[i].info_type == 3) {
                    result.result.list[i].info_type = "充值";
                    if (result.result.list[i].status == 32) {
                      result.result.list[i].status = "充值成功";
                    }
                  } else if (result.result.list[i].info_type == 4) {
                    result.result.list[i].info_type = "转账";
                    if (result.result.list[i].status == 41) {
                      result.result.list[i].status = "转出";
                    } else {
                      result.result.list[i].status = "转入";
                    }
                  } else if (result.result.list[i].info_type == 5) {
                    result.result.list[i].info_type = "红包";
                    if (result.result.list[i].status == 51) {
                      result.result.list[i].status = "转入";
                    } else {
                      result.result.list[i].status = "转出";
                    }
                  } else if (result.result.list[i].info_type == 6) {
                    result.result.list[i].info_type = "接单收入";
                    if (result.result.list[i].status == 61) {
                      result.result.list[i].status = "已完成 ";
                    }
                  } else if (result.result.list[i].info_type == 7) {
                    result.result.list[i].info_type = "接单退回";
                    if (result.result.list[i].status == 71) {
                      result.result.list[i].status = "已完成";
                    }
                  } else if (result.result.list[i].info_type == 8) {
                    result.result.list[i].info_type = "公司返款";
                    if (result.result.list[i].status == 81) {
                      result.result.list[i].status = "已完成";
                    }
                  } else if (result.result.list[i].info_type == 9) {
                    if (result.result.list[i].status == 91) {
                      result.result.list[i].info_type = "增加保证金";
                      result.result.list[i].status = "已完成";
                    } else {
                      result.result.list[i].info_type = "扣除保证金";
                      result.result.list[i].status = "已完成";
                    }
                  } else if (result.result.list[i].info_type == 10) {
                    result.result.list[i].info_type = "后台充值";
                    if (result.result.list[i].status == 101) {
                      result.result.list[i].status = "已完成";
                    }
                  } else if (result.result.list[i].info_type == 13) {
                    result.result.list[i].info_type = "退款";
                    result.result.list[i].status = "已完成";
                  } else if (result.result.list[i].info_type == 11) {
                    result.result.list[i].info_type = "提现";
                    if (result.result.list[i].status == 111) {
                      result.result.list[i].status = "申请中";
                    } else if (result.result.list[i].status == 112) {
                      result.result.list[i].status = "已完成";
                    } else if (result.result.list[i].status == 113) {
                      result.result.list[i].status = "提现失败";
                    }
                  } else if (result.result.list[i].info_type == 12) {
                    if (result.result.list[i].status == 121) {
                      result.result.list[i].status = "扣款完成";
                    }
                  } else if (result.result.list[i].info_type == 72) {

                    if (result.result.list[i].status == 721) {
                      result.result.list[i].info_type = "个人奖励";
                    } else if (result.result.list[i].status == 722) {
                      result.result.list[i].info_type = "目标奖励";
                    } else if (result.result.list[i].status == 723) {
                      result.result.list[i].info_type = "释放个人奖励";
                    } else if (result.result.list[i].status == 724) {
                      result.result.list[i].info_type = "释放目标奖励";
                    } else if (result.result.list[i].status == 725) {
                      result.result.list[i].info_type = "直属奖励";
                    } else if (result.result.list[i].status == 726) {
                      result.result.list[i].info_type = "释放直属奖励";
                    } else if (result.result.list[i].status == 727) {
                      result.result.list[i].info_type = "释放推荐奖励";
                    }
                    result.result.list[i].status = "已完成";
                  } else if (result.result.list[i].info_type == 79) {
                    if (result.result.list[i].status == 791) {
                      result.result.list[i].status = "完成";
                      result.result.list[i].info_type = "开发门店返单";
                    } else if (result.result.list[i].status == 792) {
                      result.result.list[i].status = "完成";
                      result.result.list[i].info_type = "物理区总返单";
                    } else if (result.result.list[i].status == 793) {
                      result.result.list[i].status = "完成";
                      result.result.list[i].info_type = "区负推荐人返单";
                    }
                  } else if (result.result.list[i].info_type == 67) {

                    if (result.result.list[i].status == 671) {
                      result.result.list[i].info_type = "学习积分";
                      result.result.list[i].status = "购买";
                    } else if (result.result.list[i].status == 672) {
                      result.result.list[i].info_type = "学习积分";
                      result.result.list[i].status = "转为余额";
                    }

                  } else if (result.result.list[i].info_type == 68) {

                    if (result.result.list[i].status == 681) {
                      result.result.list[i].info_type = "换货";
                      result.result.list[i].status = "已完成";
                    }

                  } else if (result.result.list[i].info_type == 69) {
                    if (result.result.list[i].status == 691) {
                      result.result.list[i].info_type = "开发门店";
                      result.result.list[i].status = "已完成";
                    }

                  }
                }
              }
              that.tableData4 = result.result.list;
              that.useTotal = result.result.data;
            }
          },
          function(err) {
            that.listLoading4 = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.listLoading4 = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },

    handleSearchGoodList() {
      this.page_size3G = 10;
      this.page_num3G = 1;
      this.searchGoodList();
    },
    searchGoodList() {
      let that = this;
      let params = {
        page_num: that.page_num3G,
        page_size: that.page_size3G,
        normal_user_id: this.userId,
        token: localStorage.getItem("api_token")
      };
      if(that.goodInfo){
        params.goodInfo = that.goodInfo;
      }
      // if (that.filtersOrder.startTime) {
      //   params.startTime = that.filtersOrder.startTime.getTime();
      // }
      // if (that.filtersOrder.endTime) {
      //   params.endTime = that.filtersOrder.endTime.getTime();
      // }
      that.listLoading255 = true;
      API.normal_user_stock_list(params)
        .then(
          function(result) {
            that.listLoading255 = false;
            if (result.key == 1000) {
              that.total_num3G = result.result.count;
              that.total_page3G = result.result.allPageNumber;
              var list = result.result.list;
              if (list && list.length > 0) {
                // for (var i = 0; i < result.result.list.length; i++) {
                //   result.result.list[i].create_time = dateFunc.formatDate(
                //     new Date(parseInt(result.result.list[i].create_time)),
                //     "yyyy-MM-dd hh:mm:ss"
                //   );
                // }
              }
              var data = result.result.data
              // list.push({"good_name": "合计", "totalPrice": (data ? data : 0)})
              that.tableData2G = result.result.list;
            }
          },
          function(err) {
            that.listLoading255 = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.listLoading4 = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },

    handleSearchReward() {
      this.page_size3 = 10;
      this.page_num3 = 1;
      this.searchReward();
    },
    searchReward() {
      let that = this;
      let params = {
        pageNum: that.page_num3,
        pageSize: that.page_size3,
        userId: this.userId,
        token: localStorage.getItem("api_token")
      };
      if (that.filtersReward.startTime) {
        params.startTime = that.filtersReward.startTime.getTime();
      }
      if (that.filtersReward.endTime) {
        params.endTime = that.filtersReward.endTime.getTime();
      }
      if (that.filtersReward.orderType) {
        params.orderType = that.filtersReward.orderType;
      }
      that.listLoading2 = true;
      API.order_list(params)
        .then(
          function(result) {
            that.listLoading2 = false;
            if (result.key == 1000) {
              that.total_num3 = result.result.count;
              that.total_page3 = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
                for (var i = 0; i < result.result.list.length; i++) {
                  result.result.list[i].create_time = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].create_time)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
                }
              }
              that.tableData2 = result.result.list;
            }
          },
          function(err) {
            that.listLoading2 = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.listLoading2 = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    handleSearchFollow() {
      this.page_size31 = 20;
      this.page_num31 = 1;
      this.followMap = {};
      this.searchUserArcInfo();
      this.searchFollowList();
    },

    searchUserArcInfo() {
      let that = this;
      let params = {
        userId: this.userId,
        token: localStorage.getItem("api_token")
      };
      API.user_arc_info(params)
        .then(
          function(result) {
            that.listLoading31 = false;
            if (result.key == 1000) {

              that.followMap = result.result.data;
              if (that.followMap != null)
              {
                that.followMap.openTime = dateFunc.formatDate(
                    new Date(parseInt(that.followMap.openTime)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
              } else {
                that.followMap = {};
              }
              console.log('aaa' + JSON.stringify(that.followMap))
            }
          },
          function(err) {
            that.listLoading31 = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.listLoading31 = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },

    handleSearchGroup() {
      this.page_size2 = 100;
      this.page_num2 = 1;
      this.searchGroupCount();
      this.searchGroup();
    },
    searchGroupCount() {
      let that = this;
      let params = {
        pageNum: that.page_num2,
        pageSize: that.page_size2,
        userId: this.userId,
        roleType: this.stu.role_type,
        type: that.filtersGroup.type,
        status:that.filtersGroup.status,
        token: localStorage.getItem("api_token")
      };
      API.group_count_total(params)
        .then(
          function(result) {
            that.listLoading1 = false;
            if (result.key == 1000) {
              that.groupMap = result.result.map;
            }
          },
          function(err) {
            that.listLoading1 = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.listLoading1 = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    searchFollowList() {
      let that = this;
      let params = {
        pageNum: that.page_num31,
        pageSize: that.page_size31,
        userId: this.userId,
        token: localStorage.getItem("api_token")
      };
      // if (that.filtersGroup.roleType && that.filtersGroup.roleType != null) {
      //   params.roleType = that.filtersGroup.roleType;
      // }
      // if (that.filtersGroup.type && that.filtersGroup.type != null) {
      //   params.type = that.filtersGroup.type;
      // }
      // if (that.filtersGroup.status && that.filtersGroup.status != null) {
      //   params.status = that.filtersGroup.status;
      // }
      // if (that.filtersGroup.username) {
      //   params.username = that.filtersGroup.username;
      // }
      that.listLoading31 = true;
      API.user_follow_list(params)
        .then(
          function(result) {
            that.listLoading31 = false;
            if (result.key == 1000) {
              that.total_num31 = result.result.count;
              that.total_page31 = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
                for (var i = 0; i < result.result.list.length; i++) {
                  result.result.list[i].createTime = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].createTime)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
                }
              }
              that.tableDataGroup31 = result.result.list;
            }
          },
          function(err) {
            that.listLoading31 = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.listLoading31 = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    searchGroup() {
      let that = this;
      let params = {
        pageNum: that.page_num2,
        pageSize: that.page_size2,
        userId: this.userId,
        token: localStorage.getItem("api_token")
      };
      if (that.filtersGroup.roleType && that.filtersGroup.roleType != null) {
        params.roleType = that.filtersGroup.roleType;
      }
      if (that.filtersGroup.type && that.filtersGroup.type != null) {
        params.type = that.filtersGroup.type;
      }
      if (that.filtersGroup.status && that.filtersGroup.status != null) {
        params.status = that.filtersGroup.status;
      }
      if (that.filtersGroup.username) {
        params.username = that.filtersGroup.username;
      }
      that.listLoading1 = true;
      API.group_count_list(params)
        .then(
          function(result) {
            that.listLoading1 = false;
            if (result.key == 1000) {
              that.total_num2 = result.result.count;
              that.total_page2 = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
              }
              that.tableDataGroup = result.result.list;
            }
          },
          function(err) {
            that.listLoading1 = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.listLoading1 = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },

    pageBack() {
      if (this.backType != null)
      {
        if (this.backType == 1)
        {
          this.$router.push({ path: "/lockUserList", query: {} });
        } else if (this.backType == 2)
        {
          this.$router.push({
            path: "/acUserList",
            query: { acId: this.activityId, acName:this.activityName }
          });
        }
      }
      else {
        this.$router.push({ path: "/normal_user_list", query: { id: 1 } });
      }
    },
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.search();
    },
    handleCurrentChangeReward(val) {
      this.searchReward();
    },
    handleCurrentChangeCangku(val) {
      this.searchGoodList();
    },
    handleCurrentChangeY(val) {
      this.searchYeji();
    },
    handleCurrentChangeIn(val) {
      this.searchIn();
    },
    handleCurrentChangeGroup(val) {
      this.searchGroup();
    },
    handleCurrentChangeOrde(val) {
      this.searchOrder();
    },
    handleClick(tab, event) {
      //selectAddress
      if (this.activeName == "second") {
        // this.get_group_user_count();
      } else if (this.activeName == "cangku") {
        this.handleSearchGoodList();
      } else if (this.activeName == "four_ua") {
        this.selectAddress();
      } else if (this.activeName == "third") {
        this.selectBank();
      } else if (this.activeName == "three") {
        this.handleSearchIn();
      } else if (this.activeName == "four") {
        this.handleSearch();
      } else if (this.activeName == "fifth") {
        this.handleSearchOrder();
      } else if (this.activeName == "riskPane") {
        this.handleSearchRiskOrder();
      } else if (this.activeName == "six") {
        this.handleSearchReward();
      } else if (this.activeName == "seven") {
        // this.handleSearch();  我的团队
        this.handleSearchGroup();
      } else if (this.activeName == "integral") {
        this.handleSearchIntegralHistory(); //学习积分明细
      } else if (this.activeName == "mm_fuww") {
        this.handleSearchFollow(); //档案信息
      } else if (this.activeName == "integral_detail") {
        this.getLog(); //积分明细
      }
    }
  }
};
</script>

<style>
.identity{
  display: flex;
  align-items: center;
  justify-content: center;
}
.identity .identity_input{
  width: 200px;
}
.identity div{
  width: 100px;
  margin-left: 20px;
}
.el-container {
  overflow-y: auto;
}
.pageStudentDetail.el-main {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
  /* margin-left: 210px; */
  background-color: #f7f7f7;
  /* padding: 0; */
  display: flex;
  flex-direction: column;
}
.pageStudentDetail .navs {
  padding: 20px 20px;
  width: 100%;
  background-color: #fff;
}
.pageStudentDetail .clientContent {
  background-color: #f7f7f7;
  padding: 20px 20px 0px 20px;
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}

.pageStudentDetail .clientContent .paraContent_body {
  /*background-color: #fff;*/
  padding-bottom: 0;
  height: 100%;
  width: 100%;
  overflow-y: auto;
  margin-left: 0;
}
.pageStudentDetail .stuDetailContent0 {
  padding-bottom: 20px;
  background-color: #f7f7f7;
}
.pageStudentDetail .stuDetailContent1 {
  display: flex;
  /*align-items: center;*/
  justify-content: flex-start;
  background-color: #fff;
}
.pageStudentDetail .stuDetailContent1 > div.userHead {
  width: 200px;
  padding: 20px;
  text-align: center;
}
.pageStudentDetail .userHead img {
  border-radius: 50%;
  width: 120px;
  height: 120px;
}
.pageStudentDetail .userHead img + div {
  margin: 10px 0 0 0;
}
.pageStudentDetail .stuDetailContent1 .userInfo {
  flex: 1;
  display: block;
  height: auto;
}
.pageStudentDetail .moreUserInfo ul {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
}
.pageStudentDetail .moreUserInfo li {
  color: #666;
  width: 33.3%;
}
.orderLi {
  padding-bottom: 15px;
}
.orderLi .orderLiTxt span + span {
  margin-left: 30px;
}
.color666 {
  color: #666;
}
.border-b {
  border-bottom: 1px solid #ededed;
}
.orderLi_content_1 {
  margin: 20px 0;
}
.orderLi_content_1 > span + span {
  margin-left: 30px;
}
.warmingTip {
  background-color: rgba(230, 247, 255, 1);
  border: 1px solid rgba(139, 209, 253, 1);
  padding: 10px 20px;
  border-radius: 3px;
}
.payBox {
  padding: 15px 30px;
}

.payBox li > div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  height: 50px;
}

.payBox li .payNum {
  display: flex;
  align-items: center;
  flex-direction: row;
}

.payBox li .colorGray span {
  color: #000;
  padding-right: 10px;
  font-size: 20px;
}
.signCourseContent .colorGray span {
  color: #000;
  padding-right: 10px;
  font-size: 20px;
}

.payBox li .colorGray span.payTotal {
  color: rgba(253, 166, 43, 1);
}
.signCourseContent .colorGray span.payTotal {
  color: rgba(253, 166, 43, 1);
}
.el-tag + .el-tag {
  margin-left: 20px;
}
.gapHeight {
  padding: 20px 0;
  border-bottom: 1px solid #ededed;
}
.handleMsg {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 20px;
}
.handleMsg > div {
  width: 50%;
  margin: 15px 0;
}
.pageStudentDetail .backPage {
  margin: 20px 0 0 20px;
}
.color999 {
  color: #999;
}
.colorC {
  color: #ccc;
}
.fontWidth {
  width: 140px;
  display: inline-block;
  text-align: right;
}
.pageStudentDetail .baseUserInfo {
  border-bottom: 1px solid #ededed;
  padding-bottom: 10px;
}
.pageStudentDetail .baseUserInfo .base_label {
  color: #000;
  font-size: 18px;
  font-weight: bold;
  margin-top: 20px;
}
.baseUserInfo > div {
  line-height: 40px;
}
.moreUserInfo .base_label {
  color: #000;
  font-size: 18px;
  font-weight: bold;
  margin: 15px 0;
}
.moreUserInfo ul li {
  line-height: 30px;
}
.stuDetailContent2 {
  margin-top: 0px;
  background-color: #fff;
}
.el-tabs__nav-wrap {
  padding: 0 30px;
}
.el-tabs__content {
  padding: 0 0 20px 0;
}

.pageStudentDetail .clientSection2 {
  margin-top: 22px;
}
.pageStudentDetail .el-form-item {
  margin-bottom: 10px;
}
.el-dialog__header {
  background-color: #2593fc;
}

.el-dialog__title {
  color: #fff;
  font-size: 16px;
}

.el-dialog__body {
  border: 1px solid rgba(237, 237, 237, 1);
}

.rightBtn {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.data-count-div {
  margin: 0 10px 20px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.data-count-div-left {
  border: 1px solid rgb(212, 211, 211);
  border-radius: 10px;
  padding: 20px;
  width: 69%;
}
.data-count-div-right {
  border: 1px solid rgb(212, 211, 211);
  border-radius: 10px;
  padding: 20px;
  width: 30%;
}
.title-left-s {
  display: inline-block;
  width: 10px;
  background-color: aqua;
  height: 20px;
  margin-right: 10px;
}
.center-data-boy {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}
.center-data-boy > div {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.data-count-div-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.data-count-div .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/user_detail.vue